import React, { useCallback, useEffect, useState, useRef } from "react";
import { Helmet } from "react-helmet";
import Alerta_Grid from "../../components/Alerta_Grid_Principal/Alerta_Grid";
import { loadGoogleMaps } from "../../utils/googleMapsLoader"
import { useQuery, useQueryClient } from "@tanstack/react-query";
import MUIDataTable from "mui-datatables";
import * as XLSX from "xlsx";
import ExampleComponent from "./fieldMuiTable";
import { ToastContainer, toast } from "react-toastify";
import Draggable from "react-draggable";
import "react-toastify/dist/ReactToastify.css";
import "./styles.scss";
import api from "../../services/api";
import Trafego from "../../assets/transito.jpg";
import pinIcon from "../../assets/pin.png";
import { renderToString } from "react-dom/server";
import { MdGpsFixed, MdGpsOff } from "react-icons/md";
import moment from "moment";
// import { MarkerClusterer } from "@googlemaps/markerclusterer";
import InfoReferencia2 from "../../components/InfoReferencia2";
import ChaveOn from "../../assets/chaveOn.png";
import ChaveOff from "../../assets/chaveOff.png";
import SireneOn from "../../assets/sireneOn.png";
import tabelaIc from "../../assets/tabela.png";
import mapaIc from "../../assets/maps.png";
import SireneOff from "../../assets/sireneOff.png";
import BateriaOn from "../../assets/bateria.png";
import BloqueioOn from "../../assets/cadeadoOn.png";
import BloqueioOff from "../../assets/cadeadoOff.png";
import Pagination from "../../components/Pagination/paginationMap";
import BateriaOff from "../../assets/bateriaOff.png";
import googleMapsUrl from "../../components/GoogleMaps/GoogleMaps";
import RefreshIcon from "@mui/icons-material/Refresh";
import CircularProgress from "@mui/material/CircularProgress";
import { FaMap } from "react-icons/fa6";
import Tooltip from "@mui/material/Tooltip";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { ClassNames } from "@emotion/react";
import Preloader from "../Preloader/Preloader"
import { IoGrid } from "react-icons/io5";
import { getToken } from "../../services/auth";
import { MdOutlineAreaChart, MdLocationPin, MdGroups } from "react-icons/md";
import Swal from "sweetalert2";
import SettingsIcon from "@mui/icons-material/Settings";




const google = (window.google = window.google ? window.google : {});


var map;
let markers = [];
var directionsService;
var directionsDisplay;
var trafficLayer;
var drawingManager;
var selectedShape;
var colors = ["#1E90FF", "#FF1493", "#32CD32", "#FF8C00", "#4B0082"];
var selectedColor;
var colorButtons = {};
var desenhos = [];
var array_forms = [];



const MapaInova = () => {
  const rotasMapRef = useRef({});

  const concentracaoInicialCalculadaRef = useRef(false);
  const [mapPronto, setMapPronto] = useState(false);
  const queryClient = useQueryClient();





  const redrawFormas = () => {
    console.log("REDRAW EXECUTOU");

    if (!map) return;

    // Limpa as formas existentes
    if (array_forms.length > 0) {
      array_forms.forEach((shape) => {
        if (shape instanceof google.maps.InfoWindow) {
          shape.close();
        } else {
          shape.setMap?.(null);
        }
      });

      array_forms = [];
    }

    // A visibilidade individual controla cada forma.
    // O global não bloqueia mais a exibição individual.
    const active_data = formas.filter((form) => {
      return (
        form.ativo === true &&
        formasIndividualVisibility[form.id] !== false
      );
    });

    DrawFormas(active_data);
  };



  //LÓGICA ATUALIZAÇÃO DE VÉICLOS A CADA 60S

  const {
    data,
    isLoading,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ["veiculos"],
    queryFn: fetchVeiculos,

    // Atualiza somente a cada 60s
    refetchInterval: 60000,

    // NÃO atualiza ao voltar para a aba
    refetchOnWindowFocus: false,

    // Opcional: atualiza ao reconectar internet
    refetchOnReconnect: true,

    // Considera os dados válidos por 60s
    staleTime: 60000,

    // Mantém cache
    cacheTime: 300000,

    // Continua atualizando em background
    refetchIntervalInBackground: true,

    // NÃO refaz requisição toda vez que o componente monta
    refetchOnMount: false,
  });


  // LÓGICA PARA DEBUGAR VEÍCULOS E MOTORISTAS
  useEffect(() => {
    if (!data?.veiculos) {

      return;
    }



  }, [data]);









  // dados
  useEffect(() => {
    if (!data?.veiculos || isLoading) return;

    setFilteredData(data.veiculos);
  }, [data, isLoading]);

  // horário
  useEffect(() => {
    if (!isFetching) {
      setDataAgora(moment().format("DD/MM/YYYY HH:mm:ss"));
    }
  }, [isFetching]);

  //--------------------------------------------------------------------

  const [modMap, setModMap] = useState("Tráfego");
  const [dataAgora, setDataAgora] = useState("");
  const [isMapVisible, setIsMapVisible] = useState(true);
  const [isTableVisible, setIsTableVisible] = useState(true);
  const [checkedItems1, setCheckedItems1] = useState({});
  const [filteredPlates, setFilteredPlates] = useState(new Set());
  const [selectAll, setSelectAll] = useState(false); // começa como "marcado"



  //


  const normalizarPlacaFiltro = (placa) =>
    String(placa ?? "")
      .replace(/['"]/g, "")
      .replace(/\s+/g, "")
      .trim()
      .toUpperCase();

  const handleCheckboxChang = (grupoId) => {
    const novosChecked = {
      ...checkedItems1,
      [grupoId]: !checkedItems1[grupoId],
    };

    const placasAtualizadas = new Set();

    reft.forEach((grupo) => {
      if (!novosChecked[grupo.id]) return;

      const veiculos = grupo.veiculos;

      const placasArray = Array.isArray(veiculos)
        ? veiculos
        : String(veiculos || "").split(",");

      placasArray.forEach((placa) => {
        const normalizada = normalizarPlacaFiltro(placa);

        if (normalizada) {
          placasAtualizadas.add(normalizada);
        }
      });
    });

    setCheckedItems1(novosChecked);
    setFilteredPlates(placasAtualizadas);
  };




  //OCULTAR SCROLL AO CLICAR EM OCULTAR TABELA
  useEffect(() => {
    if (!isTableVisible) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [isTableVisible]);

  //LÓGICA BOTÃO MAPA
  const toggleMapVisibility = () => {
    setIsMapVisible((prev) => !prev);
  };
  //LÓGICA BOTÃO TABELA
  const toggleTableVisibility = () => {
    setIsTableVisible((prev) => !prev);
  };



  //PUXA TODOS OS VEICULOS DO USUARIO(LEMBRANDO QUE REFLETE NO MAPA)
  async function fetchVeiculos() {


    const { data } = await api.get(
      "/veiculos",
      {

        params: {

          page: 1,

          limit: 10000

        },

        headers: {

          inova:
            `Bearer ${localStorage.getItem("inova")}`

        }

      }
    );

    return data;
  }




  const options = {
    filterType: "dropdown",
    // filter: false,
    pagination: false,
    body: {
      noMatch: "Nenhum dado encontrado. Verifique suas condições de filtro ou tente novamente mais tarde.", // Altere esta mensagem
    },
    selectableRows: false,
    // resizableColumns: true,
  };
  const [reft, setReft] = useState([]);
  const [checkedItems, setCheckedItems] = useState({}); // Estado para armazenar checkboxes marcadas
  const [searchTerm, setSearchTerm] = useState("");
  const [formasSearchTerm, setFormasSearchTerm] = useState("");







  const fetchData = useCallback(async () => {
    try {
      const { data } = await api.get("/grupos1", {
        headers: {
          inova: `Bearer ${localStorage.getItem("inova")}`,
        },
      });

      setReft(data);

      setCheckedItems1((prev) => {
        const novosChecked = {};

        data.forEach((grupo) => {
          novosChecked[grupo.id] =
            prev[grupo.id] ?? false;
        });

        return novosChecked;
      });
    } catch (error) {
      console.error("Erro ao buscar grupos:", error);
    }
  }, []);







  useEffect(() => {
    const atualizarLista = () => {
      fetchData();
    };

    window.addEventListener(
      "grupos-atualizados",
      atualizarLista
    );

    // Carrega os grupos ao abrir a lista
    fetchData();

    return () => {
      window.removeEventListener(
        "grupos-atualizados",
        atualizarLista
      );
    };
  }, [fetchData]);










  const toggleSelectAll = () => {
    const newCheckedItems = {};
    const newFilteredPlates = new Set();

    reft.forEach((grupo) => {
      newCheckedItems[grupo.id] = !selectAll;

      if (!selectAll) {
        grupo.veiculos
          .replace(/['"]/g, "")
          .split(",")
          .forEach((placa) => newFilteredPlates.add(placa.trim()));
      }
    });

    setCheckedItems1(newCheckedItems);
    setFilteredPlates(newFilteredPlates);
    setSelectAll(!selectAll);
  };





  const [filteredData_table, setFilteredData] = useState([]);













  // NUMERO DE VEICULOS RESPONSAVEL PELA TABELA, VINDO DA API
  // ESTADOS

  const [rowsPerPage, setRowsPerPage] = useState(20); // começa com 20 registros na tabela principal
  const [currentPage, setCurrentPage] = useState(0);
  //  --------------------------------------------------------------------------------------------------------

  // useEffect(() => {
  //   fetchDataCache(rowsPerPage, currentPage);
  // }, [rowsPerPage, currentPage]);

  //NOVA LÓGICA CONTROLE MAPA VEICULOS
  //QUERY ÚNICA







  // ----------------------------------------------------------------------------------------------------













  let marker = []; // Array global para armazenar os marcadores
  let infoWindow = null; // Referência ao InfoWindow atual
  let infoWindowMarker = null;


  function clearMap() {
    return new Promise((resolve) => {
      // Remove cada marcador do mapa
      markers.forEach((marker) => marker.setMap(null));
      markers = []; // Limpa o array de marcadores
      console.log("Mapa limpo");
      resolve(); // Resolve a Promise após a limpeza
    });
  }

  //CONFIGURAÇÃO MAPA

  function showMarker()  /*Função principal que recria os marcadores do mapa sempre que algo muda
  (ex: filtro, search, atualização, seleção de placas)*/ {
    //Remove TODOS os markers atuais do mapa
    markers.forEach((marker) => marker.setMap(null));
    markers = [];
    //------------------------------------------------

    // FILTRA QUAIS VEÍCULOS DEVEM APARECER
    // Se tem texto no search → usa o resultado da busca
    // Se não tem search → usa todos os veículos
    const baseVehicles =
      searchText && searchText.trim() !== ""
        ? filteredData
        : data?.veiculos || [];

    // Aplica APENAS o filtro de grupos (checkbox)
    const filteredVehicles = baseVehicles.filter(
      (veiculo) =>
        filteredPlates.size === 0 || filteredPlates.has(veiculo.placa)
    );


    //SE NÃO TIVER VEÍCULOS, PARA A FUNÇÃO
    if (filteredVehicles.length === 0) {
      console.log("Nenhum veículo encontrado.");
      return;
    }
    //--------------------------------------------------------------------------------------------------------------------------------



    //CRIA OS NOVOS MARCADORES VEICULOS NO MAPA
    markers = filteredVehicles.map((veiculo) => {


      //ICONE VEICULOS
      const desligado =
        veiculo.ignicao === null ||
        veiculo.ignicao === 0;

      const iconUrl = veiculo.icone_equipamento
        ? `/icones/${veiculo.icone_equipamento}${desligado ? "_off" : ""}.png`
        : "/icones/default.png";
      console.log("Ícone:", iconUrl);

      const marker = new google.maps.Marker({
        position: {
          lat: Number(veiculo.lat),
          lng: Number(veiculo.lon),
        },
        map,
        icon: iconUrl,
      });




      //-------------------------------------------------------------------------------------------------------

      //LÓGICA DE BATERIA
      const mostrarBateriaOff = veiculo.bateria <= 5;
      //---------------------------------------------------

      //Quando o usuário clica no veículo no mapa, acontece tudo abaixo 
      // INFORMAÇÕES SOBRE O VEICULO AO CLICAR
      marker.addListener("click", () => {

        // ==========================================================
        // FECHA POPUP ANTERIOR
        // ==========================================================

        if (infoWindow) {
          infoWindow.close();
        }

        infoWindowMarker = marker;


        // ==========================================================
        // SALVA A ALTURA ATUAL DO MAPA
        // ==========================================================
        // Só salva uma vez.
        // Isso evita perder a altura original caso outro veículo
        // seja clicado enquanto o popup já estiver aberto.
        // ==========================================================

        if (mapHeightAntesInfoWindow.current === null) {
          mapHeightAntesInfoWindow.current = mapHeightRef.current;
        }


        // ==========================================================
        // AUMENTA O MAPA TEMPORARIAMENTE
        // CONSEQUENTEMENTE DIMINUI A TABELA
        // ==========================================================

        const container =
          document.querySelector(".monitoramento-container");

        if (container) {

          const containerHeight =
            container.getBoundingClientRect().height;


          // Pega a altura REAL mais atual do mapa.
          //
          // Primeiro tenta a ref, porque ela representa a última
          // altura escolhida pelo usuário.
          //
          // Se ainda não existir, pega diretamente do elemento #map.
          //

          const alturaAtualMapa =
            mapHeightRef.current ??
            document
              .getElementById("map")
              ?.getBoundingClientRect()
              .height ??
            0;


          // Quanto o mapa vai ganhar de altura
          const aumentoMapa = 480;


          // Limite para não eliminar completamente a tabela
          const novaAlturaMapa = Math.min(
            alturaAtualMapa + aumentoMapa,
            containerHeight - 120
          );


          // Atualiza a ref imediatamente
          mapHeightRef.current = novaAlturaMapa;

          // Atualiza o React
          setMapHeight(novaAlturaMapa);
        }


        // ==========================================================
        // GPS
        // ==========================================================

        const gpsIcon =
          veiculo.satelites < 4
            ? renderToString(
              <MdGpsOff
                size={18}
                color="#EF4444"
              />
            )
            : renderToString(
              <MdGpsFixed
                size={18}
                color={
                  veiculo.satelites < 6
                    ? "#F59E0B"
                    : "#22C55E"
                }
              />
            );


        // ==========================================================
        // CRIA O INFOWINDOW
        // ==========================================================

        infoWindow = new google.maps.InfoWindow({

          maxWidth: 450,

          content: `

      <div style="
        width: 100%;
        max-width: 450px;
        box-sizing: border-box;
        background: #FFFFFF;
        border: 1px solid #E2E8F0;
        border-radius: 10px;
        overflow: hidden;
        font-family: Inter, Arial, sans-serif;
        box-shadow:
          0 2px 8px rgba(15,23,42,.06),
          0 8px 24px rgba(15,23,42,.08);
        position: relative;
      ">

        <!-- LINHA INOVA -->

        <div style="
          height: 2px;
          background: linear-gradient(
            90deg,
            #0F73B2 0%,
            #67A445 100%
          );
        "></div>


        <!-- HEADER -->

        <div style="
          position: relative;
          padding: 14px 16px;
          background: #F8FAFC;
          border-bottom: 1px solid #EEF2F7;
          box-sizing: border-box;
          width: 100%;
        ">

          <div style="
            font-size: 18px;
            font-weight: 700;
            color: #0F73B2;
            padding-right: 35px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          ">
            ${veiculo.placa}
          </div>


          <div style="
            font-size: 12px;
            color: #64748B;
            margin-top: 3px;
            padding-right: 35px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          ">
            ${veiculo.nome}
          </div>


          <div
            id="closeBtn"
            style="
              position: absolute;
              top: 12px;
              right: 12px;
              width: 24px;
              height: 24px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 6px;
              background: #F1F5F9;
              color: #64748B;
              cursor: pointer;
              font-size: 12px;
              font-weight: 700;
              z-index: 10;
            "
          >
            ✕
          </div>

        </div>


        <!-- STATUS -->

        <div style="
          padding: 12px 16px;
          display: flex;
          align-items: center;
          gap: 12px;
          border-bottom: 1px solid #EEF2F7;
          box-sizing: border-box;
          width: 100%;
          min-width: 0;
        ">

          <img
            src="${veiculo.bloqueio == 1 ? BloqueioOn : BloqueioOff}"
            style="
              width: 18px;
              height: 18px;
              min-width: 18px;
              max-width: 18px;
              object-fit: contain;
            "
            title="${veiculo.bloqueio == 1
              ? "Bloqueado"
              : "Desbloqueado"
            }"
          />


          <img
            src="${veiculo.ignicao == 1 || veiculo.ignicao == 2
              ? ChaveOn
              : ChaveOff
            }"
            style="
              width: 18px;
              height: 18px;
              min-width: 18px;
              max-width: 18px;
              object-fit: contain;
            "
            title="${veiculo.ignicao == 1 || veiculo.ignicao == 2
              ? "Ligado"
              : "Desligado"
            }"
          />


          <img
            src="${mostrarBateriaOff ? BateriaOn : BateriaOff}"
            style="
              width: 18px;
              height: 18px;
              min-width: 18px;
              max-width: 18px;
              object-fit: contain;
            "
            title="Bateria: ${veiculo.bateria}"
          />


          <div
            title="${veiculo.satelites < 4
              ? `Sem sinal (${veiculo.satelites} satélites)`
              : veiculo.satelites < 6
                ? `Sinal fraco (${veiculo.satelites} satélites)`
                : `Sinal forte (${veiculo.satelites} satélites)`
            }"
            style="
              margin-left: auto;
              display: flex;
              align-items: center;
              gap: 6px;
              min-width: 0;
            "
          >
            ${gpsIcon}
          </div>

        </div>


        <!-- CORPO -->

        <div style="
          padding: 15px;
          box-sizing: border-box;
          width: 100%;
          min-width: 0;
        ">


          <!-- ENDEREÇO -->

          <div style="
            margin-bottom: 16px;
            width: 100%;
            min-width: 0;
          ">

            <div style="
              font-size: 11px;
              color: #64748B;
              margin-bottom: 4px;
              text-transform: uppercase;
              letter-spacing: .5px;
            ">
              Endereço
            </div>


            <div style="
              color: #1E293B;
              font-size: 13px;
              line-height: 1.5;
              font-weight: 600;
              width: 100%;
              min-width: 0;
              overflow-wrap: anywhere;
              word-break: break-word;
            ">
              ${veiculo.endereco || "--"}
            </div>

          </div>


          <!-- GRID -->

          <div style="
            display: grid;
            grid-template-columns:
              minmax(0, 1fr)
              minmax(0, 1fr);
            gap: 14px;
            width: 100%;
            min-width: 0;
            box-sizing: border-box;
          ">


            <!-- VELOCIDADE -->

            <div style="
              min-width: 0;
              overflow: hidden;
            ">

              <div style="
                font-size: 11px;
                color: #64748B;
                margin-bottom: 4px;
              ">
                Velocidade
              </div>


              <div style="
                font-size: 22px;
                font-weight: 700;
                color: #0F73B2;
                white-space: nowrap;
              ">
                ${veiculo.velocidade}

                <span style="
                  font-size: 12px;
                  color: #64748B;
                  font-weight: 400;
                ">
                  km/h
                </span>

              </div>

            </div>


            <!-- DATA/HORA -->

            <div style="
              min-width: 0;
              overflow: hidden;
            ">

              <div style="
                font-size: 11px;
                color: #64748B;
                margin-bottom: 4px;
              ">
                Data/Hora
              </div>


              <div style="
                font-size: 12px;
                color: #1E293B;
                line-height: 1.4;
                overflow-wrap: anywhere;
                word-break: break-word;
              ">
                ${veiculo.posicao_em
              ? new Date(
                veiculo.posicao_em
              ).toLocaleString("pt-BR")
              : "--"
            }
              </div>

            </div>


            <!-- ODÔMETRO -->

            <div style="
              min-width: 0;
              overflow: hidden;
            ">

              <div style="
                font-size: 11px;
                color: #64748B;
                margin-bottom: 4px;
              ">
                Odômetro
              </div>


              <div style="
                font-size: 14px;
                color: #1E293B;
                font-weight: 600;
                white-space: nowrap;
              ">
                ${(
              Number(veiculo.hodometro) / 1000
            ).toLocaleString("pt-BR", {
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            })} Km
              </div>

            </div>


            <!-- HORÍMETRO -->

            <div style="
              min-width: 0;
              overflow: hidden;
            ">

              <div style="
                font-size: 11px;
                color: #64748B;
                margin-bottom: 4px;
              ">
                Horímetro
              </div>


              <div style="
                font-size: 14px;
                color: #1E293B;
                font-weight: 600;
                white-space: nowrap;
              ">
                ${(
              Number(veiculo.horimetro) / 60
            ).toLocaleString("pt-BR", {
              minimumFractionDigits: 1,
              maximumFractionDigits: 1
            })} h
              </div>

            </div>


          </div>

        </div>

      </div>

    `
        });


        // ==========================================================
        // ABRE O INFOWINDOW
        // ==========================================================

        infoWindow.open(map, marker);


        // ==========================================================
        // BOTÃO FECHAR
        // ==========================================================

        google.maps.event.addListenerOnce(
          infoWindow,
          "domready",
          () => {

            const closeBtn =
              document.getElementById("closeBtn");

            if (!closeBtn) return;


            closeBtn.addEventListener(
              "click",
              () => {

                // ==================================================
                // FECHA O POPUP
                // ==================================================

                infoWindow.close();


                // ==================================================
                // RESTAURA A ALTURA ORIGINAL
                // ==================================================

                if (
                  mapHeightAntesInfoWindow.current !== null
                ) {

                  const alturaOriginal =
                    mapHeightAntesInfoWindow.current;


                  // Atualiza a ref primeiro
                  mapHeightRef.current =
                    alturaOriginal;


                  // Depois atualiza o React
                  setMapHeight(
                    alturaOriginal
                  );

                }


                // ==================================================
                // LIMPA A REFERÊNCIA
                // ==================================================

                mapHeightAntesInfoWindow.current =
                  null;

              }
            );

          }
        );

      });

      return marker;
      //-----------------------------------------------------------------------------------------------
    });






  }











  const handleTrafego = () => {
    if (modMap === "Tráfego") {
      trafficLayer.setMap(map);
      setModMap("Padr&atilde;o");
    } else {
      trafficLayer.setMap(null);
      setModMap("Tr&aacute;fego");
    }
  };




  const [collapsed, setCollapsed] = useState(true);
  const [isVisibleOnlyTable, setIsVisibleOnlyTable] = useState(false);
  const menuIconClick = () => {
    setCollapsed(!collapsed);
  };

  const onlyTable = () => {
    setIsVisibleOnlyTable(!isVisibleOnlyTable);
  };
  const [isActive, setActive] = useState(false);

  const toggleClass = () => {
    setActive(!isActive);
  };
  const [referencias, setRerefencias] = useState([]);

  const [formas, setFormas] = useState([]);
  const [formasGlobalVisibility, setFormasGlobalVisibility] = useState(false);
  const [formasIndividualVisibility, setFormasIndividualVisibility] = useState({});

  async function fetchFormas() {
    try {
      const { data } = await api.get(
        "/referenciass",
        {
          headers: {
            inova: `Bearer ${localStorage.getItem("inova")}`
          }
        }
      );

      setFormas(data);

      setFormasIndividualVisibility((prev) => {
        const next = { ...prev };

        data.forEach((form) => {
          if (!(form.id in next)) {
            next[form.id] = false;
          }
        });

        return next;
      });

    } catch (error) {
      console.error(
        "Erro ao buscar formas:",
        error
      );
    }
  }



  //=========================================================
  //  LÓGICA PARA MOSTRAR/OCULTAR FORMAS GLOBAIS
  //=========================================================
  const toggleFormasGlobalVisibility = () => {
    setFormasGlobalVisibility((prevGlobal) => {
      const newState = !prevGlobal;

      console.log("GLOBAL FORMAS:", newState);

      setFormasIndividualVisibility((prev) => {
        const updated = { ...prev };

        formas.forEach((form) => {
          updated[form.id] = newState;
        });

        return updated;
      });

      return newState;
    });
  };

  //=========================================================
  //  LÓGICA PARA MOSTRAR/OCULTAR FORMAS INDIVIDUAIS
  //=========================================================
  const toggleIndividualForma = (id) => {
    setFormasIndividualVisibility((prev) => ({
      ...prev,
      [id]: !(prev[id] ?? true),
    }));
  };




  useEffect(() => {



    fetchFormas();

  }, []);


  // =========================================================
  // DESENHA / OCULTA FORMAS NO MAPA
  // =========================================================
  useEffect(() => {
    if (!map) return;

    console.log("=== ATUALIZANDO FORMAS ===");
    console.log("GLOBAL:", formasGlobalVisibility);
    console.log("TOTAL FORMAS:", formas.length);

    const activeData = formas.filter((form) => {
      const visivelIndividual =
        formasIndividualVisibility[form.id] ?? true;

      return (
        form.ativo === true &&
        visivelIndividual
      );
    });

    console.log(
      "FORMAS ATIVAS:",
      activeData.map((form) => ({
        id: form.id,
        tipo: form.tipo,
        descricao: form.descricao,
      }))
    );

    DrawFormas(activeData);
  }, [
    map,
    formas,
    formasGlobalVisibility,
    formasIndividualVisibility,
  ]);




  // =========================================================
  // CRIA PIN COLORIDO
  // =========================================================
  const criarPinColorido = (cor) => {
    const svg = `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="52"
      viewBox="0 0 42 52"
    >
      <defs>
        <filter
          id="shadow"
          x="-50%"
          y="-50%"
          width="200%"
          height="200%"
        >
          <feDropShadow
            dx="0"
            dy="2"
            stdDeviation="2"
            flood-opacity="0.35"
          />
        </filter>
      </defs>

      <path
        d="M21 1C9.95 1 1 9.95 1 21
           C1 35 21 51 21 51
           C21 51 41 35 41 21
           C41 9.95 32.05 1 21 1Z"
        fill="${cor}"
        stroke="#ffffff"
        stroke-width="2"
        filter="url(#shadow)"
      />

      <circle
        cx="21"
        cy="21"
        r="7"
        fill="#ffffff"
      />
    </svg>
  `;

    return {
      url:
        "data:image/svg+xml;charset=UTF-8," +
        encodeURIComponent(svg),

      scaledSize: new window.google.maps.Size(32, 40),

      anchor: new window.google.maps.Point(16, 40),
    };
  };



  // =========================================================
  // LIMPA FORMAS ANTIGAS
  // =========================================================
  function DrawFormas(active_data) {

    console.log("ARRAY_FORMS:", array_forms.length);

    if (!map) return;

    if (array_forms.length > 0) {

      array_forms.forEach((shape) => {

        if (shape instanceof google.maps.InfoWindow) {

          shape.close();

        } else {

          shape.setMap?.(null);
        }
      });

      array_forms = [];
    }

    active_data.forEach((draw) => {
      console.log(
        "TIPO:",
        draw.tipo,
        "ID:",
        draw.id
      );



      desenharForma(draw);

    });
  }

  // =========================================================
  // DESENHA FORMA NO MAPA
  // =========================================================
  function desenharForma(draw, destacar = false) {
    let bounds = new google.maps.LatLngBounds();
    let center;
    let zoomLevel = 10; // Zoom padrão

    // =====================================================
    // POLÍGONO
    // =====================================================

    if (draw.tipo === "polygon") {

      const paths = JSON.parse(draw.obj_google);

      paths.forEach((coord) =>
        bounds.extend(
          new google.maps.LatLng(
            coord.lat,
            coord.lng
          )
        )
      );

      const polygon = new google.maps.Polygon({
        paths,

        strokeColor:
          draw.cor || "#2563eb",

        strokeOpacity: 1,

        strokeWeight: 2,

        fillColor:
          draw.cor || "#2563eb",

        fillOpacity: 0.35,

        map,
      });

      array_forms.push(polygon);

      // ====================================
      // ÁREA
      // ====================================

      const area =
        google.maps.geometry.spherical.computeArea(
          polygon.getPath()
        );

      const areaTexto =
        area >= 1000000
          ? `${(area / 1000000).toFixed(2)} km²`
          : `${area.toFixed(0)} m²`;

      // ====================================
      // TOOLTIP
      // ====================================

      const infoWindow =
        new google.maps.InfoWindow({
          content: `
<div style="
  background: rgba(15,23,42,.96);
  color:white;
  padding:10px 16px;
  border-radius:999px;
  font-size:12px;
  font-weight:600;
  box-shadow:0 8px 25px rgba(0,0,0,.35);
  border:1px solid rgba(255,255,255,.08);
  white-space:nowrap;
  display:flex;
  align-items:center;
  gap:8px;
">

  <div style="
    width:10px;
    height:10px;
    border-radius:50%;
    background:${draw.cor || "#2563eb"};
  ">
  </div>

  <span>
    ${draw.descricao || "Polígono"}

    <span style="
      opacity:.75;
      font-weight:500;
    ">
      • ${areaTexto}
    </span>
  </span>

</div>
`
        });

      polygon.addListener(
        "mouseover",
        (e) => {

          infoWindow.setPosition(
            e.latLng
          );

          infoWindow.open({
            map,
          });
        }
      );

      polygon.addListener(
        "mouseout",
        () => {

          infoWindow.close();
        }
      );

      array_forms.push(infoWindow);
    }

    // =====================================================
    // CÍRCULO
    // =====================================================
    // =====================================================
    // CÍRCULO
    // =====================================================
    else if (draw.tipo === "circulo") {

      console.log("=== DESENHANDO CÍRCULO ===");
      console.log("ID:", draw.id);
      console.log("LAT:", draw.lat);
      console.log("LON:", draw.lon);
      console.log("RAIO:", draw.raio);

      const center = new google.maps.LatLng(
        Number(draw.lat),
        Number(draw.lon)
      );

      const circle = new google.maps.Circle({
        center: center,
        radius: Number(draw.raio),
        strokeColor: draw.cor || "#2563eb",
        strokeOpacity: 1,
        strokeWeight: 2,
        fillColor: draw.cor || "#2563eb",
        fillOpacity: 0.35,
        map: map,
      });

      // Guarda SOMENTE uma vez
      array_forms.push(circle);

      console.log("CÍRCULO CRIADO:", draw.id);
      console.log("MAP:", circle.getMap());
      console.log("CENTER:", circle.getCenter().toString());
      console.log("RADIUS:", circle.getRadius());

      // =====================================================
      // TOOLTIP
      // =====================================================

      const raioTexto =
        Number(draw.raio) >= 1000
          ? `${(Number(draw.raio) / 1000).toFixed(1)} km`
          : `${Number(draw.raio).toFixed(0)} m`;

      const infoWindow = new google.maps.InfoWindow({
        content: `
      <div style="
        background: rgba(15,23,42,.96);
        color:white;
        padding:10px 16px;
        border-radius:999px;
        font-size:12px;
        font-weight:600;
        box-shadow:0 8px 25px rgba(0,0,0,.35);
        white-space:nowrap;
      ">
        <div style="
          display:flex;
          align-items:center;
          gap:8px;
        ">
          <div style="
            width:10px;
            height:10px;
            border-radius:50%;
            background:${draw.cor || "#2563eb"};
          "></div>

          <span>
            ${draw.descricao || "Círculo"}

            <span style="
              opacity:.75;
              font-weight:500;
            ">
              • ${raioTexto}
            </span>
          </span>
        </div>
      </div>
    `
      });

      circle.addListener("mouseover", (e) => {

        infoWindow.setPosition(e.latLng);

        infoWindow.open({
          map: map,
        });

      });

      circle.addListener("mouseout", () => {
        infoWindow.close();
      });

      // Guarda o InfoWindow
      array_forms.push(infoWindow);

      // Bounds do círculo
      bounds.union(circle.getBounds());

      // =====================================================
      // SE FOI CLICADO NO BOTÃO "MOSTRAR NO MAPA"
      // =====================================================

      if (destacar) {

        console.log("CENTRALIZANDO CÍRCULO:", draw.id);

        map.fitBounds(circle.getBounds());

      }
    }

    // =====================================================
    // RETÂNGULO
    // =====================================================

    else if (draw.tipo === "rectangule") {

      const rectangle =
        new google.maps.Rectangle({

          bounds: {
            north: Number(draw.north),
            south: Number(draw.south),
            east: Number(draw.east),
            west: Number(draw.west),
          },

          strokeColor:
            draw.cor || "#2563eb",

          strokeOpacity: 1,

          strokeWeight: 2,

          fillColor:
            draw.cor || "#2563eb",

          fillOpacity: 0.35,

          map,
        });

      array_forms.push(rectangle);

      bounds.extend(
        new google.maps.LatLng(
          draw.north,
          draw.east
        )
      );

      bounds.extend(
        new google.maps.LatLng(
          draw.south,
          draw.west
        )
      );

      // =====================================
      // ÁREA
      // =====================================

      const largura =
        google.maps.geometry.spherical.computeDistanceBetween(

          new google.maps.LatLng(
            draw.north,
            draw.west
          ),

          new google.maps.LatLng(
            draw.north,
            draw.east
          )
        );

      const altura =
        google.maps.geometry.spherical.computeDistanceBetween(

          new google.maps.LatLng(
            draw.north,
            draw.west
          ),

          new google.maps.LatLng(
            draw.south,
            draw.west
          )
        );

      const area =
        largura * altura;

      const areaTexto =
        area >= 1000000
          ? `${(area / 1000000).toFixed(2)} km²`
          : `${area.toFixed(0)} m²`;

      // =====================================
      // TOOLTIP
      // =====================================

      const infoWindow =
        new google.maps.InfoWindow({

          content: `
<div style="
  background: rgba(15,23,42,.96);
  color:white;
  padding:10px 16px;
  border-radius:999px;
  font-size:12px;
  font-weight:600;
  box-shadow:0 8px 25px rgba(0,0,0,.35);
  border:1px solid rgba(255,255,255,.08);
  white-space:nowrap;
  display:flex;
  align-items:center;
  gap:8px;
">

  <div style="
    width:10px;
    height:10px;
    border-radius:50%;
    background:${draw.cor || "#2563eb"};
  ">
  </div>

  <span>
    ${draw.descricao || "Retângulo"}

    <span style="
      opacity:.75;
      font-weight:500;
    ">
      • ${areaTexto}
    </span>
  </span>

</div>
`
        });

      rectangle.addListener(
        "mouseover",
        (e) => {

          infoWindow.setPosition(
            e.latLng
          );

          infoWindow.open({
            map,
          });
        }
      );

      rectangle.addListener(
        "mouseout",
        () => {

          infoWindow.close();
        }
      );

      array_forms.push(infoWindow);
    }

    // =====================================================
    // ROTA
    // =====================================================

    else if (draw.tipo === "rota") {

      if (!draw.obj_google) return;

      if (destacar && rotasMapRef.current[draw.id]) {

        const rotaExistente = rotasMapRef.current[draw.id];

        // ====================================
        // CENTRALIZA A ROTA EXISTENTE
        // ====================================

        const boundsExistente =
          new google.maps.LatLngBounds();

        rotaExistente.polyline
          .getPath()
          .forEach((coord) => {
            boundsExistente.extend(coord);
          });

        map.fitBounds(boundsExistente);

        // ====================================
        // DESTAQUE VISUAL
        // ====================================

        let ciclo = 0;

        const animacao = setInterval(() => {

          ciclo++;

          const destaque = ciclo % 2 === 1;

          // LINHA
          rotaExistente.polyline.setOptions({
            strokeOpacity: destaque ? 1 : 0.35,
            strokeWeight: destaque ? 6 : 4,
          });

          // MARKERS
          rotaExistente.markers.forEach((marker) => {

            marker.setOpacity(
              destaque ? 1 : 0.35
            );

            marker.setIcon({
              ...criarPinColorido(
                draw.cor || "#2563eb"
              ),

              scaledSize: new google.maps.Size(
                destaque ? 38 : 32,
                destaque ? 48 : 40
              ),

              anchor: new google.maps.Point(
                destaque ? 19 : 16,
                destaque ? 48 : 40
              ),
            });

          });

          // FINALIZA
          if (ciclo >= 16) {

            clearInterval(animacao);

            rotaExistente.polyline.setOptions({
              strokeOpacity: 1,
              strokeWeight: 4,
            });

            rotaExistente.markers.forEach((marker) => {

              marker.setOpacity(1);

              marker.setIcon({
                ...criarPinColorido(
                  draw.cor || "#2563eb"
                ),

                scaledSize: new google.maps.Size(
                  32,
                  40
                ),

                anchor: new google.maps.Point(
                  16,
                  40
                ),
              });

            });

          }

        }, 650);

        return;
      }

      // =====================================================
      // TOOLTIP DOS MARKERS
      // =====================================================

      const criarTooltipMarker = (
        marker,
        tipoPonto
      ) => {

        const tooltip =
          document.createElement("div");

        tooltip.style.position =
          "absolute";

        tooltip.style.pointerEvents =
          "none";

        tooltip.style.opacity =
          "0";

        tooltip.style.transition =
          "all .18s ease";

        tooltip.style.transform =
          "translate(-50%, -105%) scale(.95)";

        tooltip.innerHTML = `
<div style="
  background: rgba(15,23,42,.96);
  color:white;
  padding:10px 16px;
  border-radius:999px;
  font-size:12px;
  font-weight:600;
  letter-spacing:.3px;
  box-shadow:0 8px 25px rgba(0,0,0,.35);
  border:1px solid rgba(255,255,255,.08);
  backdrop-filter:blur(6px);
  white-space:nowrap;
  display:flex;
  align-items:center;
  gap:8px;
">

  <div style="
    width:10px;
    height:10px;
    border-radius:50%;
    background:${draw.cor || "#2563eb"};
    box-shadow:0 0 12px ${draw.cor || "#2563eb"};
  ">
  </div>

  <span>
    ${draw.descricao || "Rota"}

    <span style="
      opacity:.75;
      font-weight:500;
    ">
      • ${tipoPonto}
    </span>
  </span>

</div>
`;

        const overlay =
          new google.maps.OverlayView();

        overlay.onAdd = function () {

          this.getPanes()
            .floatPane
            .appendChild(tooltip);
        };

        overlay.draw = function () {

          const projection =
            this.getProjection();

          const position =
            projection.fromLatLngToDivPixel(
              marker.getPosition()
            );

          tooltip.style.left =
            position.x + "px";

          tooltip.style.top =
            position.y + "px";
        };

        overlay.onRemove = function () {

          tooltip.remove();
        };

        let hoverTimeout;

        marker.addListener(
          "mouseover",
          () => {

            clearTimeout(
              hoverTimeout
            );

            overlay.setMap(map);

            requestAnimationFrame(() => {

              tooltip.style.opacity =
                "1";

              tooltip.style.transform =
                "translate(-50%, -120%) scale(1)";
            });
          }
        );

        marker.addListener(
          "mouseout",
          () => {

            hoverTimeout =
              setTimeout(() => {

                tooltip.style.opacity =
                  "0";

                tooltip.style.transform =
                  "translate(-50%, -105%) scale(.95)";

                setTimeout(() => {

                  overlay.setMap(null);

                }, 120);

              }, 80);
          }
        );
      };

      // =====================================================
      // COORDENADAS DA ROTA
      // =====================================================

      let str_waypoints =
        draw.obj_google
          .replace(/\(/g, "")
          .replace(/\)/g, "")
          .split("|");

      let poliline =
        str_waypoints.map((val) => {

          const valor =
            val.split(",");

          return {
            lat: parseFloat(valor[0]),
            lng: parseFloat(valor[1]),
          };
        });

      if (!poliline.length) return;

      // =====================================================
      // LINHA DA ROTA
      // =====================================================

      const polyline =
        new google.maps.Polyline({

          path: poliline,

          strokeColor:
            draw.cor || "#2563eb",

          strokeOpacity: 1,

          strokeWeight: 4,

          map,
        });

      array_forms.push(
        polyline
      );

      // =====================================================
      // TOOLTIP DA LINHA
      // =====================================================

      const infoWindow =
        new google.maps.InfoWindow({

          content: `
<div style="
  background: rgba(15,23,42,.96);
  color:white;
  padding:10px 16px;
  border-radius:999px;
  font-size:12px;
  font-weight:600;
  letter-spacing:.3px;
  box-shadow:0 8px 25px rgba(0,0,0,.35);
  border:1px solid rgba(255,255,255,.08);
  white-space:nowrap;
  display:flex;
  align-items:center;
  gap:8px;
">

  <div style="
    width:10px;
    height:10px;
    border-radius:50%;
    background:${draw.cor || "#2563eb"};
  ">
  </div>

  <span>
    ${draw.descricao}

    <span style="
      opacity:.75;
      font-weight:500;
    ">
      • Rota
    </span>
  </span>

</div>
`
        });

      polyline.addListener(
        "mouseover",
        (e) => {

          infoWindow.setPosition(
            e.latLng
          );

          infoWindow.open({
            map,
          });
        }
      );

      polyline.addListener(
        "mouseout",
        () => {

          infoWindow.close();
        }
      );

      // =====================================================
      // ARRAY DOS MARKERS DA ROTA
      // =====================================================

      const markersRota = [];

      // =====================================================
      // ORIGEM
      // =====================================================

      const markerOrigem =
        new google.maps.Marker({

          position:
            poliline[0],

          map,

          icon:
            criarPinColorido(
              draw.cor || "#2563eb"
            ),
        });

      // =====================================================
      // DESTINO
      // =====================================================

      const markerDestino =
        new google.maps.Marker({

          position:
            poliline[
            poliline.length - 1
            ],

          map,

          icon:
            criarPinColorido(
              draw.cor || "#2563eb"
            ),
        });

      array_forms.push(
        markerOrigem
      );

      array_forms.push(
        markerDestino
      );

      markersRota.push(
        markerOrigem
      );

      markersRota.push(
        markerDestino
      );

      // =====================================================
      // PARADAS DA ROTA
      // =====================================================

      if (draw.north) {

        const cleaned =
          draw.north
            .replace(/^{{/, "")
            .replace(/}}$/, "");

        const points =
          cleaned.split("},{");

        const paradas =
          points.map((coord) => {

            const [lat, lng] =
              coord
                .replace("{", "")
                .replace("}", "")
                .split(",");

            return {
              lat: parseFloat(lat),
              lng: parseFloat(lng),
            };
          });

        // ====================================
        // POINTS PARA ORIGEM,
        // DESTINO E PARADAS
        // ====================================

        paradas.forEach(
          (coord, index) => {

            const tipoPonto =
              index === 0
                ? "Origem"
                : index === paradas.length - 1
                  ? "Destino"
                  : `Parada ${index}`;

            const marker =
              new google.maps.Marker({

                position:
                  coord,

                map,

                icon:
                  criarPinColorido(
                    draw.cor || "#2563eb"
                  ),
              });

            array_forms.push(
              marker
            );

            markersRota.push(
              marker
            );

            criarTooltipMarker(
              marker,
              tipoPonto
            );
          }
        );
      }

      // =====================================================
      // GUARDA A ROTA JÁ CRIADA
      // =====================================================

      rotasMapRef.current[draw.id] = {
        polyline,
        markers: markersRota,
      };













      // =====================================================
      // DESTAQUE VISUAL DA ROTA
      // =====================================================

      if (destacar) {

        const rotaExistente = rotasMapRef.current[draw.id];

        // Se a rota já existe no mapa, usa ela.
        if (rotaExistente) {

          let ciclo = 0;

          const animacao = setInterval(() => {

            ciclo++;

            const destaque = ciclo % 2 === 1;

            // ====================================
            // LINHA DA ROTA
            // ====================================

            rotaExistente.polyline.setOptions({
              strokeOpacity: destaque ? 1 : 0.35,
              strokeWeight: destaque ? 6 : 4,
            });

            // ====================================
            // MARKERS / ÍCONES
            // ====================================

            rotaExistente.markers.forEach((marker) => {

              marker.setOpacity(
                destaque ? 1 : 0.35
              );

              marker.setIcon({
                ...criarPinColorido(
                  draw.cor || "#2563eb"
                ),

                scaledSize: new google.maps.Size(
                  destaque ? 38 : 32,
                  destaque ? 48 : 40
                ),

                anchor: new google.maps.Point(
                  destaque ? 19 : 16,
                  destaque ? 48 : 40
                ),
              });

            });

            // ====================================
            // FINALIZA
            // ====================================

            if (ciclo >= 8) {

              clearInterval(animacao);

              rotaExistente.polyline.setOptions({
                strokeOpacity: 1,
                strokeWeight: 4,
              });

              rotaExistente.markers.forEach((marker) => {

                marker.setOpacity(1);

                marker.setIcon({
                  ...criarPinColorido(
                    draw.cor || "#2563eb"
                  ),

                  scaledSize: new google.maps.Size(
                    32,
                    40
                  ),

                  anchor: new google.maps.Point(
                    16,
                    40
                  ),
                });

              });

            }

          }, 650);

        }

      }

      // =====================================================
      // BOUNDS
      // =====================================================

      poliline.forEach(
        (coord) => {

          bounds.extend(
            new google.maps.LatLng(
              coord.lat,
              coord.lng
            )
          );
        }
      );
    }

    // =====================================================
    // AJUSTA VISUALIZAÇÃO DO MAPA
    // =====================================================


  }
  // ============================================================
  // FORMATAR DATA PARA BUSCA
  // ============================================================

  // ============================================================
  // FORMATAR DATA PARA BUSCA
  // ============================================================

  const formatarDataBusca = (valor) => {

    // Se não existir uma data,
    // retorna uma string vazia.
    if (!valor) return "";

    // Converte o valor para Date.
    const data = new Date(valor);

    // Verifica se a data é válida.
    if (isNaN(data.getTime())) {

      // Caso não seja uma data válida,
      // retorna o próprio valor normalizado.
      return normalizarBusca(valor);
    }

    // Retorna no formato brasileiro:
    //
    // 2026-10-05T10:30:00
    // ↓
    // 05/10/2026

    return data.toLocaleDateString("pt-BR");
  };


  // ============================================================
  // TEXTO DIGITADO NO CAMPO DE BUSCA
  // ============================================================

  const [searchText, setSearchText] = useState("");


  // ============================================================
  // NORMALIZAÇÃO DA BUSCA
  // ============================================================
  //
  // Aceita maiúsculas, minúsculas e acentos.
  //
  // Exemplos:
  //
  // "JOÃO"       → "joao"
  // "João"       → "joao"
  // " joao "     → "joao"
  // "SÃO PAULO"  → "sao paulo"
  //

  const normalizarBusca = (valor) => {

    return String(valor || "")

      // Remove acentos
      .normalize("NFD")

      .replace(
        /[\u0300-\u036f]/g,
        ""
      )

      // Converte para minúsculo
      .toLowerCase()

      // Remove espaços das extremidades
      .trim()

      // Remove espaços duplicados
      .replace(
        /\s+/g,
        " "
      );
  };


  // ============================================================
  // NORMALIZAÇÃO ESPECÍFICA PARA PLACA
  // ============================================================
  //
  // Também ignora:
  // - espaços
  // - hífen
  // - maiúsculas/minúsculas
  //
  // Exemplos:
  //
  // ABC-1234 → abc1234
  // abc 1234 → abc1234
  // ABC1234  → abc1234
  //

  const normalizarPlaca = (valor) => {

    return normalizarBusca(valor)

      .replace(
        /[\s-]/g,
        ""
      );
  };








  const filteredData =

    (filteredData_table || []).filter(

      (veiculo) => {



        // ======================================================
        // TEXTO DIGITADO
        // ======================================================

        const busca =
          normalizarBusca(searchText);


        // ======================================================
        // MOTORISTA
        // ======================================================

        const motorista =
          normalizarBusca(
            veiculo.motora
          );

        const textoMotorista =
          motorista ||
          normalizarBusca("Motorista não logado");


        // ======================================================
        // DATA
        // ======================================================

        const data =
          normalizarBusca(
            formatarDataBusca(
              veiculo.posicao_em
            )
          );


        // ======================================================
        // ENDEREÇO
        // ======================================================

        const endereco =
          normalizarBusca(
            veiculo.endereco
          );


        // ======================================================
        // DESCRIÇÃO
        // ======================================================
        //
        // A descrição vem do campo "nome"
        // do equipamento.
        //
        // Exemplo:
        //
        // veiculo.nome = "Caminhão João"
        //
        // busca = "caminhao"
        //
        // Resultado:
        // true

        const descricao =
          normalizarBusca(
            veiculo.nome
          );


        // ======================================================
        // PLACA
        // ======================================================

        const placa =
          normalizarPlaca(
            veiculo.placa
          );


        // ======================================================
        // MODELO
        // ======================================================
        //
        // Exemplo:
        //
        // veiculo.modelo = "GV-300CAN"
        //
        // busca = "gv300can"
        //
        // Observação:
        // aqui usamos normalizarBusca, portanto o hífen
        // ainda é mantido.
        //
        // Se quiser ignorar hífen também no modelo,
        // podemos usar normalizarPlaca.

        const modelo =
          normalizarBusca(
            veiculo.modelo
          );


        // ======================================================
        // BUSCA NO MOTORISTA
        // ======================================================

        const matchMotorista =
          textoMotorista.includes(
            busca
          );


        // ======================================================
        // BUSCA NA DATA
        // ======================================================

        const matchData =
          data.includes(
            busca
          );


        // ======================================================
        // BUSCA NO ENDEREÇO
        // ======================================================

        const matchEndereco =
          endereco.includes(
            busca
          );


        // ======================================================
        // BUSCA NA DESCRIÇÃO
        // ======================================================

        const matchDescricao =
          descricao.includes(
            busca
          );


        // ======================================================
        // BUSCA NA PLACA
        // ======================================================
        //
        // Usa normalizarPlaca nos dois lados.
        //
        // Assim:
        //
        // placa cadastrada:
        // ABC-1234
        //
        // usuário digita:
        // abc1234
        //
        // também encontra.

        const buscaPlaca =
          normalizarPlaca(
            busca
          );

        const matchPlaca =
          placa.includes(
            buscaPlaca
          );


        // ======================================================
        // BUSCA NO MODELO
        // ======================================================

        const matchModelo =
          modelo.includes(
            busca
          );


        // ======================================================
        // RESULTADO DA BUSCA DE TEXTO
        // ======================================================
        //
        // O veículo será encontrado se a busca estiver em:
        //
        // ✔ Motorista
        // ✔ Data
        // ✔ Endereço
        // ✔ Descrição
        // ✔ Placa
        // ✔ Modelo

        const matchTexto =
          !busca ||
          matchMotorista ||
          matchData ||
          matchEndereco ||
          matchDescricao ||
          matchPlaca ||
          matchModelo;


        // ======================================================
        // FILTRO DE PLACAS SELECIONADAS
        // ======================================================


        const normalizarPlacaFiltro = (valor) =>
          String(valor ?? "")
            .replace(/[\s\u00A0]+/g, "")
            .trim()
            .toUpperCase();

        const placasSelecionadasNormalizadas = new Set(
          Array.from(filteredPlates, normalizarPlacaFiltro)
        );

        const placaNormalizada = normalizarPlacaFiltro(veiculo.placa);



        const matchFiltroPlacas =
          filteredPlates.size === 0 ||
          filteredPlates.has(
            normalizarPlacaFiltro(veiculo.placa)
          );





        return matchTexto && matchFiltroPlacas;

      }
    );


  const { columns } = ExampleComponent({
    map,
    filteredData,
  });














  useEffect(() => {
    if (!data?.veiculos || isLoading) return;

    clearMap();
    showMarker(data.veiculos);
  }, [data, isLoading, checkedItems1, filteredPlates, searchText]);












  // LÓGICA EXIBIÇÃO TABELA RESPONSIVA 

  const [responsiveMode, setResponsiveMode] = useState("standard");

  useEffect(() => {
    const mapaOculto = !isMapVisible || !toggleMapVisibility;
    const muitosDados = filteredData.length >= 50;

    if (mapaOculto) {
      // mapa oculto → força altura fixa
      setResponsiveMode("standard");
    } else if (muitosDados) {
      // mapa visível + muitos dados → scroll
      setResponsiveMode("scrollMaxHeight");
    } else {
      // mapa visível + poucos dados → normal
      setResponsiveMode("standard");
    }
  }, [filteredData, isMapVisible, toggleMapVisibility]);



  // SELECIONAR LINAHS DA TABELA PRINCIPAL
  const [selectedRows, setSelectedRows] = useState([]);

  const handleRowClick = (rowData, rowMeta) => {
    const { dataIndex } = rowMeta;
    setSelectedRows((prev) =>
      prev.includes(dataIndex) ? [] : [dataIndex]
    );
  };

  // LÓGICA SELÇÃO LINHA
  const tableOptions = {
    onRowClick: handleRowClick,
    setRowProps: (row, dataIndex) => {
      const isSelected = selectedRows.includes(dataIndex);
      return {
        className: isSelected ? "table-row tabela-linha--selecao-ativa" : "tabela-selecao-linha-nao_ativa",
      };
    },
  };





  // VERIFICANDO CONVERSA API  E TABELA


  // /* console.log("REGISTROS COMPLETOS DA API:", data.total);



  useEffect(() => {
    const totalPages = Math.ceil(filteredData.length / rowsPerPage);

    if (currentPage >= totalPages && totalPages > 0) {
      setCurrentPage(0);
    }
  }, [filteredData.length, rowsPerPage]);


  //========================================================
  // COLUNAS VISIVEIS POR PADRÃO
  //========================================================
  const colunasPadrao = {
    motorista_apelido: false,
    obs_b: false,
    posicao_em: true,
    satelites: true,
    endereco: true,
    horimetro: true,
    hodometro: true,
    velocidade: true,
    temperatura: false,
    equipamento: true,
    lat: true,
    lon: true,

    // CAN
    rpm_can: false,
    temperatura_motor_can: false,
    nivel_tanque_can: false,
  };


  const [visibleColumns, setVisibleColumns] = useState(() => {
    const saved = localStorage.getItem("visibleColumns");

    if (saved) {
      try {
        return JSON.parse(saved);
      } catch (error) {
        console.error("Erro ao carregar colunas salvas:", error);
      }
    }

    return colunasPadrao;
  });


  // DEFINIÇÃO DE COLUNAS CONFIGURÁVEIS || add COLUNAS
  const colunasConfiguraveis = [
    { key: "motorista_apelido", label: "Motorista" },
    // { key: "posicao_em", label: "Data/Hora" },
    { key: "obs_b", label: "Observação" },
    // { key: "satelites", label: "Satélite" },
    // { key: "endereco", label: "Endereço" },
    { key: "horimetro", label: "Horímetro" },
    { key: "hodometro", label: "Odômetro" },
    // { key: "velocidade", label: "Velocidade" },
    { key: "temperatura", label: "Temperatura" },
    // { key: "equipamento", label: "Equipamento" },
    // { key: "lat", label: "Latitude/Longitude" },
    // { key: "lon", label: "Longitude" },

    // =========================
    // DADOS DA REDE CAN
    // =========================

    { key: "rpm_can", label: "RPM" },

    { key: "temperatura_motor_can", label: "Temperatura do Motor" },

    { key: "nivel_tanque_can", label: "Nível do Tanque" },












  ];

  // FUNÇÃO PARA ABRIR CONFIGURAÇÃO DE COLUNAS COM CHECKBOXES

  const abrirConfiguracaoColunas = async () => {
    // =====================================================
    // HTML DAS COLUNAS
    // =====================================================

    const html = colunasConfiguraveis
      .map(
        (coluna) => `
        <label
          for="${coluna.key}"
          class="coluna-option"
        >
          <input
            type="checkbox"
            id="${coluna.key}"
            ${visibleColumns?.[coluna.key] !== false ? "checked" : ""}
          />

          <span class="coluna-option-text">
            ${coluna.label}
          </span>
        </label>
      `
      )
      .join("");

    // =====================================================
    // MODAL DE PERSONALIZAÇÃO
    // =====================================================

    const { value, isDenied } = await Swal.fire({
      titleText: "Personalizar colunas",

      html: `
      <div class="swal-colunas-description">
        Escolha as informações que deseja visualizar
        na tabela.
      </div>

      <div class="swal-colunas-section-title">
        COLUNAS DISPONÍVEIS
      </div>

      <div class="swal-colunas-grid">
        ${html}
      </div>
    `,

      width: 560,

      background: "#0b1622",
      color: "#eaf0f8",

      showCancelButton: true,
      showDenyButton: true,

      confirmButtonText: "Salvar alterações",
      denyButtonText: "Restaurar padrão",
      cancelButtonText: "Cancelar",

      buttonsStyling: false,
      reverseButtons: false,
      focusConfirm: false,

      customClass: {
        popup: "swal-colunas-popup",
        title: "titulo-config-colunas",
        htmlContainer: "swal-colunas-content",
        actions: "swal-colunas-actions",
        confirmButton: "swal-colunas-save",
        denyButton: "swal-colunas-reset",
        cancelButton: "swal-colunas-cancel",
      },

      preConfirm: () => {
        const resultado = {};

        colunasConfiguraveis.forEach((coluna) => {
          const checkbox = document.getElementById(coluna.key);

          if (checkbox) {
            resultado[coluna.key] = checkbox.checked;
          }
        });

        return resultado;
      },
    });

    // =====================================================
    // RESTAURAR PADRÃO
    // =====================================================


    if (isDenied) {
      const confirmacao = await Swal.fire({
        titleText: "Restaurar padrão",

        html: `
      <div class="inova-reset-content">
        <div class="inova-reset-icon">
          <svg
            viewBox="0 0 24 24"
            width="27"
            height="27"
            fill="none"
            stroke="currentColor"
            stroke-width="1.7"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <path d="M3 12a9 9 0 1 0 3-6.7L3 8"/>
            <path d="M3 3v5h5"/>
            <path d="M12 7v5l3 2"/>
          </svg>
        </div>

        <p class="inova-reset-message">
          Deseja restaurar as colunas para a
          configuração original do sistema?
        </p>

        <div class="inova-reset-note">
          <span class="inova-reset-dot"></span>
          Suas preferências atuais serão substituídas.
        </div>
      </div>
    `,

        width: 390,
        padding: "28px",

        background: "#0b1622",
        color: "#edf3fa",

        showCancelButton: true,

        confirmButtonText: "Sim, restaurar",
        cancelButtonText: "Manter configuração",

        reverseButtons: true,
        buttonsStyling: false,
        focusCancel: true,

        customClass: {
          popup: "inova-reset-popup",
          title: "inova-reset-title",
          htmlContainer: "inova-reset-html",
          actions: "inova-reset-actions",
          confirmButton: "inova-reset-confirm",
          cancelButton: "inova-reset-cancel",
        },
      });

      // Usuário cancelou a confirmação
      if (!confirmacao.isConfirmed) {
        return;
      }

      // ===================================================
      // CONFIGURAÇÃO PADRÃO ORIGINAL
      // ===================================================

      const colunasPadrao = {
        motorista_apelido: false,
        obs_b: false,
        posicao_em: true,
        satelites: true,
        endereco: true,
        horimetro: true,
        hodometro: true,
        velocidade: true,
        temperatura: false,
        equipamento: true,
        lat: true,
        lon: true,

        // CAN
        rpm_can: false,
        temperatura_motor_can: false,
        nivel_tanque_can: false,
      };

      setVisibleColumns(colunasPadrao);

      localStorage.setItem(
        "visibleColumns",
        JSON.stringify(colunasPadrao)
      );

      // ===================================================
      // CONFIRMAÇÃO PREMIUM
      // ===================================================

      await Swal.fire({
        titleText: "Tudo em ordem",

        html: `
      <div class="inova-reset-success-content">
        <div class="inova-reset-success-icon">
          <svg
            viewBox="0 0 24 24"
            width="27"
            height="27"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <path d="m5 12 4 4L19 6"/>
          </svg>
        </div>

        <p class="inova-reset-success-message">
          Configuração padrão restaurada.
        </p>

        <span class="inova-reset-success-detail">
          As colunas serão atualizadas ao continuar.
        </span>
      </div>
    `,

        width: 360,
        padding: "28px",

        background: "#0b1622",
        color: "#edf3fa",

        showConfirmButton: true,
        confirmButtonText: "Continuar",

        buttonsStyling: false,

        customClass: {
          popup: "inova-reset-success-popup",
          title: "inova-reset-success-title",
          htmlContainer: "inova-reset-success-html",
          actions: "inova-reset-success-actions",
          confirmButton: "inova-reset-success-confirm",
        },
      });

      window.location.reload();

      return;
    }


    // =====================================================
    // CANCELAR OU FECHAR
    // =====================================================

    if (!value) {
      return;
    }

    // =====================================================
    // SALVAR CONFIGURAÇÃO
    // =====================================================

    setVisibleColumns(value);

    localStorage.setItem(
      "visibleColumns",
      JSON.stringify(value)
    );

    // =====================================================
    // LOADING PREMIUM
    // =====================================================


    Swal.fire({
      titleText: "Aplicando alterações",

      html: `
    <div class="inova-loading-content">
      <div class="inova-loading-spinner">
        <span></span>
      </div>

      <div class="inova-loading-text">
        <span class="inova-loading-status">
          Atualizando suas colunas
        </span>

        <span class="inova-loading-description">
          Preparando a visualização...
        </span>
      </div>
    </div>
  `,

      width: 340,
      padding: "24px",

      background: "#0b1622",
      color: "#f1f5f9",

      showConfirmButton: false,
      showCancelButton: false,
      showDenyButton: false,
      showCloseButton: false,

      allowOutsideClick: false,
      allowEscapeKey: false,

      timer: 1200,
      timerProgressBar: false,

      customClass: {
        popup: "inova-loading-popup",
        title: "inova-loading-title",
        htmlContainer: "inova-loading-html",
      },
    }).then(() => {
      window.location.reload();
    });

  };


  // =========================================================
  // EXPORTAÇÃO EXCEL — EXATAMENTE COMO O GRID
  // =========================================================
  // =========================================================
  // EXPORTAÇÃO EXCEL — IGUAL AO GRID
  // =========================================================
  const exportarExcel = useCallback(() => {
    try {
      // =========================================================
      // SOMENTE OS REGISTROS DA PÁGINA ATUAL
      // =========================================================

      const inicio = currentPage * rowsPerPage;
      const fim = inicio + rowsPerPage;

      const dados = (filteredData || []).slice(inicio, fim);

      if (!dados.length) {
        Swal.fire({
          icon: "warning",
          title: "Nenhum dado para exportar",
          text: "Não existem registros na página atual para exportar.",
          confirmButtonText: "Fechar",
        });

        return;
      }

      // =========================================================
      // MESMA CONFIGURAÇÃO DO GRID
      //
      // false = oculto
      // true  = visível
      //
      // As colunas "excluded" do fieldMuiTable NÃO entram.
      // =========================================================

      const colunasExcel = [
        {
          key: "placa",
          label: "Placa",
          visible: true,
          valor: (v) => {
            let placa = String(v.placa || "")
              .toUpperCase()
              .trim();

            if (/^[A-Z]{3}[0-9]{4}$/.test(placa)) {
              placa =
                `${placa.substring(0, 3)}-${placa.substring(3)}`;
            }

            return placa || "Sem placa";
          },
        },

        {
          key: "nome",
          label: "Descrição",
          visible: true,
          valor: (v) =>
            v.nome && String(v.nome).trim()
              ? String(v.nome)
              : "N/A",
        },

        {
          key: "motora",

          label: "Motorista",

          visible:
            visibleColumns?.motorista_apelido !== false,

          valor: (v) =>
            v.motora !== null &&
              v.motora !== undefined &&
              String(v.motora).trim()
              ? String(v.motora)
              : "Motorista não logado",
        },
        {
          key: "obs_b",
          label: "Observação",
          visible:
            visibleColumns?.obs_b !== false,
          valor: (v) =>
            v.observacao_data &&
              String(v.observacao_data).trim()
              ? String(v.observacao_data)
              : "N/A",
        },

        {
          key: "posicao_em",
          label: "DT/HR",
          visible:
            visibleColumns?.posicao_em !== false,
          valor: (v) => {
            if (!v.posicao_em) return "--";

            const data = new Date(v.posicao_em);

            return isNaN(data.getTime())
              ? "--"
              : data.toLocaleString("pt-BR");
          },
        },

        {
          key: "endereco",
          label: "Endereço",
          visible:
            visibleColumns?.endereco !== false,
          valor: (v) =>
            v.endereco &&
              String(v.endereco).trim()
              ? String(v.endereco)
              : "Endereço não disponível",
        },

        {
          key: "horimetro",
          label: "Horímetro",
          visible:
            visibleColumns?.horimetro !== false,
          valor: (v) => {
            if (
              v.horimetro === null ||
              v.horimetro === undefined ||
              v.horimetro === ""
            ) {
              return "N/A";
            }

            const valor = Number(v.horimetro);

            return isNaN(valor)
              ? "N/A"
              : `${(valor / 60).toLocaleString(
                "pt-BR",
                {
                  minimumFractionDigits: 1,
                  maximumFractionDigits: 1,
                }
              )} h`;
          },
        },

        {
          key: "hodometro",
          label: "Odômetro",
          visible:
            visibleColumns?.hodometro !== false,
          valor: (v) => {
            if (
              v.hodometro === null ||
              v.hodometro === undefined ||
              v.hodometro === ""
            ) {
              return "N/A";
            }

            const valor = Number(v.hodometro);

            return isNaN(valor)
              ? "N/A"
              : `${(valor / 1000).toLocaleString(
                "pt-BR",
                {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                }
              )} Km`;
          },
        },

        {
          key: "velocidade",
          label: "Velocidade",
          visible:
            visibleColumns?.velocidade !== false,
          valor: (v) =>
            v.velocidade !== null &&
              v.velocidade !== undefined
              ? `${v.velocidade} km/h`
              : "-",
        },

        {
          key: "temperatura",
          label: "Temperatura",
          visible:
            visibleColumns?.temperatura !== false,
          valor: (v) =>
            v.temperatura !== null &&
              v.temperatura !== undefined
              ? `${v.temperatura}°C`
              : "N/A",
        },

        {
          key: "equipamento",
          label: "Equipamento",

          // No fieldMuiTable:
          // display: "excluded"
          // Portanto NÃO aparece no Excel.
          visible: false,

          valor: (v) =>
            v.equipamento !== null &&
              v.equipamento !== undefined
              ? v.equipamento
              : "-",
        },

        {
          key: "satelites",
          label: "Satélite",

          // No fieldMuiTable:
          // display: "excluded"
          visible: false,

          valor: (v) =>
            v.satelites !== null &&
              v.satelites !== undefined
              ? v.satelites
              : "-",
        },

        {
          key: "lat",
          label: "Latitude",

          // No fieldMuiTable:
          // display: "excluded"
          visible: false,

          valor: (v) =>
            v.lat !== null &&
              v.lat !== undefined
              ? v.lat
              : "",
        },

        {
          key: "lon",
          label: "Longitude",

          // No fieldMuiTable:
          // display: "excluded"
          visible: false,

          valor: (v) =>
            v.lon !== null &&
              v.lon !== undefined
              ? v.lon
              : "",
        },

        {
          key: "rpm_can",
          label: "RPM",
          visible:
            visibleColumns?.rpm_can !== false,
          valor: (v) =>
            v.rpm_can !== null &&
              v.rpm_can !== undefined &&
              v.rpm_can !== ""
              ? v.rpm_can
              : "N/A",
        },

        {
          key: "temperatura_motor_can",
          label: "Temperatura Motor",
          visible:
            visibleColumns?.temperatura_motor_can !== false,
          valor: (v) =>
            v.temperatura_motor_can !== null &&
              v.temperatura_motor_can !== undefined &&
              v.temperatura_motor_can !== ""
              ? `${v.temperatura_motor_can}°C`
              : "N/A",
        },

        {
          key: "nivel_tanque_can",
          label: "Nível Tanque",
          visible:
            visibleColumns?.nivel_tanque_can !== false,
          valor: (v) =>
            v.nivel_tanque_can !== null &&
              v.nivel_tanque_can !== undefined &&
              v.nivel_tanque_can !== ""
              ? v.nivel_tanque_can
              : "N/A",
        },
      ];

      // =========================================================
      // SOMENTE COLUNAS VISÍVEIS
      // =========================================================

      const colunasVisiveis =
        colunasExcel.filter(
          (coluna) => coluna.visible
        );

      // =========================================================
      // DADOS
      // =========================================================

      const dadosExcel = dados.map((veiculo) => {
        const linha = {};

        colunasVisiveis.forEach((coluna) => {
          linha[coluna.label] =
            coluna.valor(veiculo);
        });

        return linha;
      });

      // =========================================================
      // DATA / HORA
      // =========================================================

      const agora = new Date();

      const dataHoraGeracao =
        agora.toLocaleString("pt-BR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        });

      // =========================================================
      // WORKSHEET
      // =========================================================

      const worksheet =
        XLSX.utils.aoa_to_sheet([
          ["RELATÓRIO DE VEÍCULOS"],
          [`Gerado em: ${dataHoraGeracao}`],
          [`Registros exibidos: ${dados.length}`],
          [],
          colunasVisiveis.map(
            (coluna) => coluna.label
          ),
          ...dadosExcel.map((linha) =>
            colunasVisiveis.map(
              (coluna) =>
                linha[coluna.label]
            )
          ),
        ]);

      // =========================================================
      // LARGURA DAS COLUNAS
      // =========================================================

      worksheet["!cols"] =
        colunasVisiveis.map((coluna) => {
          switch (coluna.key) {
            case "placa":
              return { wch: 14 };

            case "nome":
              return { wch: 28 };

            case "motora":
              return { wch: 24 };

            case "obs_b":
              return { wch: 30 };

            case "posicao_em":
              return { wch: 20 };

            case "endereco":
              return { wch: 55 };

            case "horimetro":
            case "hodometro":
              return { wch: 16 };

            case "velocidade":
            case "temperatura":
              return { wch: 16 };

            case "rpm_can":
              return { wch: 12 };

            case "temperatura_motor_can":
              return { wch: 24 };

            case "nivel_tanque_can":
              return { wch: 20 };

            default:
              return { wch: 16 };
          }
        });

      // =========================================================
      // MESCLAR TÍTULO
      // =========================================================

      worksheet["!merges"] = [
        {
          s: { r: 0, c: 0 },
          e: {
            r: 0,
            c: colunasVisiveis.length - 1,
          },
        },
      ];

      // =========================================================
      // ESTILO DO TÍTULO
      // =========================================================

      for (
        let c = 0;
        c < colunasVisiveis.length;
        c++
      ) {
        const celula =
          XLSX.utils.encode_cell({
            r: 0,
            c,
          });

        worksheet[celula] =
          worksheet[celula] || {};

        worksheet[celula].s = {
          font: {
            bold: true,
            sz: 18,
            color: {
              rgb: "FFFFFF",
            },
          },
          fill: {
            fgColor: {
              rgb: "1F4E78",
            },
          },
          alignment: {
            horizontal: "left",
            vertical: "center",
          },
        };
      }

      // =========================================================
      // CABEÇALHO
      // =========================================================

      const linhaCabecalho = 4;

      for (
        let c = 0;
        c < colunasVisiveis.length;
        c++
      ) {
        const celula =
          XLSX.utils.encode_cell({
            r: linhaCabecalho,
            c,
          });

        if (!worksheet[celula]) continue;

        worksheet[celula].s = {
          font: {
            bold: true,
            sz: 11,
            color: {
              rgb: "FFFFFF",
            },
          },
          fill: {
            fgColor: {
              rgb: "4472C4",
            },
          },
          alignment: {
            horizontal: "center",
            vertical: "center",
            wrapText: true,
          },
          border: {
            top: {
              style: "thin",
              color: {
                rgb: "D9E2F3",
              },
            },
            bottom: {
              style: "thin",
              color: {
                rgb: "D9E2F3",
              },
            },
            left: {
              style: "thin",
              color: {
                rgb: "D9E2F3",
              },
            },
            right: {
              style: "thin",
              color: {
                rgb: "D9E2F3",
              },
            },
          },
        };
      }

      // =========================================================
      // ESTILO DOS DADOS
      // =========================================================

      const primeiraLinhaDados = 5;

      for (
        let r = primeiraLinhaDados;
        r <
        primeiraLinhaDados +
        dadosExcel.length;
        r++
      ) {
        for (
          let c = 0;
          c < colunasVisiveis.length;
          c++
        ) {
          const celula =
            XLSX.utils.encode_cell({
              r,
              c,
            });

          if (!worksheet[celula]) continue;

          const coluna =
            colunasVisiveis[c];

          const alinhamento =
            coluna.key === "endereco" ||
              coluna.key === "nome" ||
              coluna.key ===
              "motorista_apelido" ||
              coluna.key === "obs_b"
              ? "left"
              : "center";

          worksheet[celula].s = {
            font: {
              sz: 10,
              color: {
                rgb: "333333",
              },
            },
            alignment: {
              horizontal: alinhamento,
              vertical: "center",
              wrapText: true,
            },
            border: {
              bottom: {
                style: "hair",
                color: {
                  rgb: "E5E7EB",
                },
              },
            },
          };
        }
      }

      // =========================================================
      // ALTURA DAS LINHAS
      // =========================================================

      worksheet["!rows"] = [];

      worksheet["!rows"][0] = {
        hpt: 28,
      };

      worksheet["!rows"][1] = {
        hpt: 18,
      };

      worksheet["!rows"][2] = {
        hpt: 18,
      };

      worksheet["!rows"][4] = {
        hpt: 30,
      };

      for (
        let r = primeiraLinhaDados;
        r <
        primeiraLinhaDados +
        dadosExcel.length;
        r++
      ) {
        worksheet["!rows"][r] = {
          hpt: 22,
        };
      }

      // =========================================================
      // CONGELAR CABEÇALHO
      // =========================================================

      worksheet["!freeze"] = {
        xSplit: 0,
        ySplit: 5,
      };

      // =========================================================
      // FILTRO
      // =========================================================

      if (dadosExcel.length > 0) {
        worksheet["!autofilter"] = {
          ref:
            XLSX.utils.encode_range({
              s: {
                r: 4,
                c: 0,
              },
              e: {
                r: 4 + dadosExcel.length,
                c:
                  colunasVisiveis.length - 1,
              },
            }),
        };
      }

      // =========================================================
      // WORKBOOK
      // =========================================================

      const workbook =
        XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        "Veículos"
      );

      // =========================================================
      // NOME DO ARQUIVO
      // =========================================================

      const dataArquivo =
        agora
          .toLocaleDateString("pt-BR")
          .replace(/\//g, "-");

      const nomeArquivo =
        `Relatorio_Veiculos_${dataArquivo}.xlsx`;

      // =========================================================
      // DOWNLOAD
      // =========================================================

      XLSX.writeFile(
        workbook,
        nomeArquivo
      );

    } catch (error) {
      console.error(
        "Erro ao gerar Excel:",
        error
      );

      Swal.fire({
        icon: "error",
        title: "Erro ao gerar Excel",
        text: "Não foi possível gerar o relatório.",
        confirmButtonText: "Fechar",
      });
    }
  }, [
    filteredData,
    visibleColumns,
    currentPage,
    rowsPerPage,
  ]);
  //===========================================
  //CAPTURA CLICK
  //===========================================
  useEffect(() => {
    const handleDownloadExcel = (event) => {
      const botao = event.target.closest(
        '[data-testid="DownloadCSV-iconButton"]'
      );

      if (!botao) return;

      event.preventDefault();
      event.stopPropagation();

      exportarExcel();
    };

    document.addEventListener(
      "click",
      handleDownloadExcel,
      true
    );

    return () => {
      document.removeEventListener(
        "click",
        handleDownloadExcel,
        true
      );
    };
  }, [exportarExcel]);



  useEffect(() => {
    const initMap = async () => {
      // =====================================================
      // GOOGLE MAPS
      // =====================================================

      if (!window.google || !window.google.maps) {
        console.log("❌ Google Maps não carregado");
        return;
      }

      // =====================================================
      // MAPA JÁ EXISTE
      // =====================================================

      if (map instanceof window.google.maps.Map) {
        console.log("🗺️ Mapa já existe");

        if (!mapPronto) {
          setMapPronto(true);
        }

        return;
      }

      // =====================================================
      // DIV DO MAPA
      // =====================================================

      const mapDiv = document.getElementById("map");

      if (!mapDiv) {
        console.log("❌ Div #map não encontrada");
        return;
      }

      // =====================================================
      // TRAFFIC
      // =====================================================

      trafficLayer =
        new window.google.maps.TrafficLayer();

      // =====================================================
      // AUTOCOMPLETE
      // =====================================================

      const options = {
        types: ["geocode"],
      };

      // =====================================================
      // LIMITES DO MAPA
      // =====================================================

      const worldBounds = {
        north: 80,
        south: -80,
        west: -179.8,
        east: 179.8,
      };

      // =====================================================
      // CONFIGURAÇÃO INICIAL
      // =====================================================

      const mapOptions = {
        zoom: 10,

        // Centro padrão apenas enquanto a concentração
        // ainda não foi calculada.
        center: {
          lat: -23.6821604,
          lng: -46.8754848,
        },

        zoomControl: true,

        gestureHandling: "greedy",

        minZoom: 1,

        restriction: {
          latLngBounds: worldBounds,
          strictBounds: true,
        },
      };

      // =====================================================
      // CRIA MAPA
      // =====================================================

      console.log("🗺️ Criando mapa...");

      map = new window.google.maps.Map(
        mapDiv,
        mapOptions
      );

      console.log("✅ MAPA PRINCIPAL CRIADO");

      // =====================================================
      // AVISA QUE O MAPA ESTÁ PRONTO
      // =====================================================

      setMapPronto(true);

      // =====================================================
      // AUTOCOMPLETE - PARTIDA
      // =====================================================

      const input1 =
        document.getElementById("ponto_partida");

      if (input1) {
        new window.google.maps.places.Autocomplete(
          input1,
          options
        );
      }

      // =====================================================
      // AUTOCOMPLETE - DESTINO
      // =====================================================

      const input2 =
        document.getElementById("ponto_destino");

      if (input2) {
        new window.google.maps.places.Autocomplete(
          input2,
          options
        );
      }

      // =====================================================
      // SEARCH BOX
      // =====================================================

      const input3 =
        document.getElementById("input-localizar");

      if (!input3) {
        console.log(
          "⚠️ input-localizar não encontrado"
        );

        return;
      }

      const searchBox =
        new window.google.maps.places.SearchBox(
          input3
        );

      map.controls[
        window.google.maps.ControlPosition.CENTER
      ].push(input3);

      // =====================================================
      // ATUALIZA BOUNDS DO SEARCH
      // =====================================================

      map.addListener(
        "bounds_changed",
        () => {
          searchBox.setBounds(
            map.getBounds()
          );
        }
      );

      // =====================================================
      // MARCADORES DO SEARCH
      // =====================================================

      let markersPoint = [];

      // =====================================================
      // PESQUISA DE ENDEREÇO
      // =====================================================

      searchBox.addListener(
        "places_changed",
        () => {
          const places =
            searchBox.getPlaces();

          if (
            !places ||
            places.length === 0
          ) {
            return;
          }

          // -------------------------------------------------
          // REMOVE MARCADORES ANTERIORES DO SEARCH
          // -------------------------------------------------

          markersPoint.forEach(
            (marker) => {
              marker.setMap(null);
            }
          );

          markersPoint = [];

          // -------------------------------------------------
          // BOUNDS
          // -------------------------------------------------

          const bounds =
            new window.google.maps.LatLngBounds();

          // -------------------------------------------------
          // CRIA MARCADORES
          // -------------------------------------------------

          places.forEach((place) => {
            if (
              !place.geometry ||
              !place.geometry.location
            ) {
              return;
            }

            const icon = {
              url: place.icon,

              size:
                new window.google.maps.Size(
                  71,
                  71
                ),

              origin:
                new window.google.maps.Point(
                  0,
                  0
                ),

              anchor:
                new window.google.maps.Point(
                  17,
                  34
                ),

              scaledSize:
                new window.google.maps.Size(
                  25,
                  25
                ),
            };

            const marker =
              new window.google.maps.Marker({
                map,

                icon,

                title:
                  place.name,

                position:
                  place.geometry.location,
              });

            markersPoint.push(marker);

            // -------------------------------------------------
            // BOUNDS DO LOCAL
            // -------------------------------------------------

            if (
              place.geometry.viewport
            ) {
              bounds.union(
                place.geometry.viewport
              );
            } else {
              bounds.extend(
                place.geometry.location
              );
            }
          });

          // -------------------------------------------------
          // ENQUADRA RESULTADO
          // -------------------------------------------------

          map.fitBounds(bounds);
        }
      );

      console.log("✅ MAPA PRINCIPAL OK");
    };

    // =====================================================
    // CARREGA GOOGLE MAPS
    // =====================================================

    loadGoogleMaps().then(() => {
      initMap();
    });

    // IMPORTANTE:
    // O MAPA É CRIADO SOMENTE UMA VEZ.
  }, []);

  useEffect(() => {
    // =====================================================
    // JÁ CALCULOU?
    // =====================================================

    if (concentracaoInicialCalculadaRef.current) {
      return;
    }

    // =====================================================
    // MAPA AINDA NÃO ESTÁ PRONTO
    // =====================================================

    if (!mapPronto) {
      return;
    }

    if (
      !(map instanceof window.google.maps.Map)
    ) {
      return;
    }

    // =====================================================
    // AINDA NÃO TEM VEÍCULOS
    // =====================================================

    if (
      !data?.veiculos ||
      !data.veiculos.length
    ) {

      return;
    }

    // =====================================================
    // DISTÂNCIA ENTRE DOIS PONTOS
    // =====================================================

    const distanciaKm = (
      lat1,
      lon1,
      lat2,
      lon2
    ) => {
      const R = 6371;

      const dLat =
        ((lat2 - lat1) * Math.PI) / 180;

      const dLon =
        ((lon2 - lon1) * Math.PI) / 180;

      const a =
        Math.sin(dLat / 2) *
        Math.sin(dLat / 2) +

        Math.cos(
          (lat1 * Math.PI) / 180
        ) *

        Math.cos(
          (lat2 * Math.PI) / 180
        ) *

        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);

      const c =
        2 *
        Math.atan2(
          Math.sqrt(a),
          Math.sqrt(1 - a)
        );

      return R * c;
    };

    // =====================================================
    // CONVERTE E VALIDA VEÍCULOS
    // =====================================================

    const veiculosValidos =
      data.veiculos
        .map((veiculo) => ({
          ...veiculo,

          latitude: Number(
            veiculo.lat
          ),

          longitude: Number(
            veiculo.lon
          ),
        }))
        .filter(
          (veiculo) =>
            Number.isFinite(
              veiculo.latitude
            ) &&

            Number.isFinite(
              veiculo.longitude
            ) &&

            veiculo.latitude >= -90 &&

            veiculo.latitude <= 90 &&

            veiculo.longitude >= -180 &&

            veiculo.longitude <= 180
        );




    // =====================================================
    // NENHUM VEÍCULO VÁLIDO
    // =====================================================

    if (!veiculosValidos.length) {
      console.log(
        "⚠️ Nenhum veículo com coordenada válida."
      );

      // Marca como calculado para não ficar
      // tentando indefinidamente.
      concentracaoInicialCalculadaRef.current =
        true;

      return;
    }

    // =====================================================
    // RAIO DA CONCENTRAÇÃO
    // =====================================================

    const RAIO_CONCENTRACAO_KM = 25;

    // =====================================================
    // PROCURA A MAIOR CONCENTRAÇÃO
    // =====================================================

    let maiorGrupo = [];

    let maiorQuantidade = 0;

    veiculosValidos.forEach(
      (
        veiculoBase,
        indexBase
      ) => {
        const grupoAtual = [];

        veiculosValidos.forEach(
          (
            veiculoComparado,
            indexComparado
          ) => {

            // ------------------------------------------------
            // O PRÓPRIO VEÍCULO JÁ FAZ PARTE DO GRUPO
            // ------------------------------------------------

            if (
              indexBase ===
              indexComparado
            ) {
              grupoAtual.push(
                veiculoComparado
              );

              return;
            }

            // ------------------------------------------------
            // CALCULA DISTÂNCIA
            // ------------------------------------------------

            const distancia =
              distanciaKm(
                veiculoBase.latitude,
                veiculoBase.longitude,

                veiculoComparado.latitude,
                veiculoComparado.longitude
              );

            // ------------------------------------------------
            // ESTÁ DENTRO DO RAIO?
            // ------------------------------------------------

            if (
              distancia <=
              RAIO_CONCENTRACAO_KM
            ) {
              grupoAtual.push(
                veiculoComparado
              );
            }
          }
        );

        // ----------------------------------------------------
        // VERIFICA SE É O MAIOR GRUPO
        // ----------------------------------------------------

        if (
          grupoAtual.length >
          maiorQuantidade
        ) {
          maiorQuantidade =
            grupoAtual.length;

          maiorGrupo =
            grupoAtual;
        }
      }
    );

    // =====================================================
    // SEGURANÇA
    // =====================================================

    if (!maiorGrupo.length) {
      maiorGrupo = [
        veiculosValidos[0],
      ];
    }

    // =====================================================
    // CALCULA CENTRO DO GRUPO
    // =====================================================

    const soma =
      maiorGrupo.reduce(
        (acc, veiculo) => {
          acc.lat +=
            veiculo.latitude;

          acc.lng +=
            veiculo.longitude;

          return acc;
        },
        {
          lat: 0,
          lng: 0,
        }
      );

    const centro = {
      lat:
        soma.lat /
        maiorGrupo.length,

      lng:
        soma.lng /
        maiorGrupo.length,
    };

    // =====================================================
    // LOG
    // =====================================================

    console.log(
      "📊 MAIOR CONCENTRAÇÃO ENCONTRADA"
    );

    console.log(
      "🚗 Quantidade:",
      maiorGrupo.length
    );

    console.log(
      "📍 Centro:",
      centro
    );

    console.log(
      "📏 Raio:",
      RAIO_CONCENTRACAO_KM,
      "km"
    );

    console.log(
      "========================================"
    );

    // =====================================================
    // CENTRALIZA O MAPA
    // =====================================================

    map.setCenter(centro);

    // SEMPRE ZOOM 10
    map.setZoom(10);

    // =====================================================
    // MARCA COMO CALCULADO
    // =====================================================

    concentracaoInicialCalculadaRef.current =
      true;

    console.log(
      "✅ Centralização inicial concluída."
    );
  }, [data, mapPronto]);





  // ============================================================
  // CONTROLA SE O USUÁRIO ESTÁ REDIMENSIONANDO O MAPA
  // ============================================================
  // true  = usuário está segurando o mouse e arrastando
  // false = usuário não está redimensionando
  const [isResizingMap, setIsResizingMap] = useState(false);
  const [mapHeight, setMapHeight] = useState(null);
  const mapHeightAntesInfoWindow = useRef(null);
  const mapHeightRef = useRef(null);


  // ============================================================
  // INICIA O REDIMENSIONAMENTO DO MAPA
  // ============================================================
  // Essa função é chamada quando o usuário clica na barra
  // que fica entre o mapa e a tabela.
  const startResizeMap = (e) => {
    e.preventDefault();

    setIsResizingMap(true);

    // Evita selecionar texto enquanto arrasta
    document.body.style.userSelect = "none";
    document.body.style.cursor = "ns-resize";
  };

  // ============================================================
  // CONTROLA O MOVIMENTO DO MOUSE DURANTE O REDIMENSIONAMENTO
  // ============================================================
  //
  // Enquanto o usuário estiver segurando a barra:
  //
  //     mouse para cima   → aumenta o mapa
  //     mouse para baixo  → diminui o mapa
  //
  // ============================================================
  useEffect(() => {
    if (!isResizingMap) return;

    let animationFrame = null;

    const handlePointerMove = (e) => {
      const container = document.querySelector(".monitoramento-container");

      if (!container) return;

      const rect = container.getBoundingClientRect();

      // Posição do mouse dentro do container
      const mouseY = e.clientY - rect.top;

      // Altura diretamente em pixels
      const newHeight = mouseY;

      // Atualização visual imediata
      if (animationFrame) {
        cancelAnimationFrame(animationFrame);
      }

      animationFrame = requestAnimationFrame(() => {
        setMapHeight(newHeight);
      });
    };

    const handlePointerUp = () => {
      setIsResizingMap(false);

      document.body.style.userSelect = "";
      document.body.style.cursor = "";

      if (animationFrame) {
        cancelAnimationFrame(animationFrame);
      }
    };

    document.addEventListener("pointermove", handlePointerMove);
    document.addEventListener("pointerup", handlePointerUp);

    return () => {
      document.removeEventListener("pointermove", handlePointerMove);
      document.removeEventListener("pointerup", handlePointerUp);

      if (animationFrame) {
        cancelAnimationFrame(animationFrame);
      }

      document.body.style.userSelect = "";
      document.body.style.cursor = "";
    };
  }, [isResizingMap]);

  useEffect(() => {
    mapHeightRef.current = mapHeight;
  }, [mapHeight]);

  // ============================================================
  // ATUALIZA O GOOGLE MAPS QUANDO A ALTURA DO MAPA MUDA
  // ============================================================
  useEffect(() => {
    if (!map || mapHeight === null) return;

    const animationFrame = requestAnimationFrame(() => {
      google.maps.event.trigger(map, "resize");

      if (infoWindow && infoWindowMarker) {
        const position = infoWindowMarker.getPosition();

        if (position) {
          infoWindow.setPosition(position);
        }
      }
    });

    return () => {
      cancelAnimationFrame(animationFrame);
    };
  }, [mapHeight]);

  useEffect(() => {
    mapHeightRef.current = mapHeight;
  }, [mapHeight]);















  // ========================================================
  // CENTRALIZA FORMA NO MAPA
  // - Círculo: usa raio
  // - Rota: usa todos os pontos
  // - Retângulo: usa os limites
  // - Polígono: usa todos os vértices
  // ========================================================
  // ========================================================
  // CENTRALIZA E DESTACA UMA FORMA NO MAPA
  // ========================================================
  const handleCenterForma = (draw) => {


    if (!map) {
      console.error("❌ MAPA NÃO DISPONÍVEL");
      return;
    }

    if (!window.google?.maps) {
      console.error("❌ GOOGLE MAPS NÃO DISPONÍVEL");
      return;
    }

    const type = draw.tipo;

    const latitude = Number(draw.lat);
    const longitude = Number(draw.lon);
    const raio = Number(draw.raio);

    const center = draw.center;

    // ======================================================
    // CÍRCULO
    // ======================================================
    if (type === "circulo") {
      if (
        !isNaN(latitude) &&
        !isNaN(longitude) &&
        !isNaN(raio)
      ) {
        const centerPoint =
          new google.maps.LatLng(
            latitude,
            longitude
          );

        const circle =
          new google.maps.Circle({
            center: centerPoint,
            radius: raio,
          });

        const bounds =
          circle.getBounds();

        if (bounds) {
          map.fitBounds(bounds);
        } else {
          map.panTo(centerPoint);
          map.setZoom(15);
        }
      }

      return;
    }

    // ======================================================
    // ROTA
    // ======================================================
    if (type === "rota") {
      console.log("🚗 PROCESSANDO ROTA");

      // ====================================================
      // PRIMEIRO: VERIFICA SE A ROTA JÁ ESTÁ DESENHADA
      // ====================================================
      const rotaExistente =
        rotasMapRef.current[draw.id];

      console.log(
        "ROTA EXISTENTE:",
        rotaExistente
      );

      if (rotaExistente?.polyline) {
        console.log(
          "✅ USANDO ROTA EXISTENTE"
        );

        // ================================================
        // CENTRALIZA NA ROTA
        // ================================================
        const bounds =
          new google.maps.LatLngBounds();

        rotaExistente.polyline
          .getPath()
          .forEach((coord) => {
            bounds.extend(coord);
          });

        if (!bounds.isEmpty()) {
          console.log(
            "🎯 CENTRALIZANDO NA ROTA"
          );

          map.fitBounds(bounds);
        }

        // ================================================
        // DESTAQUE DA ROTA
        // ================================================
        let ciclo = 0;

        const animacao =
          setInterval(() => {
            ciclo++;

            const destaque =
              ciclo % 2 === 1;

            // --------------------------------------------
            // LINHA
            // --------------------------------------------
            rotaExistente.polyline.setOptions({
              strokeOpacity:
                destaque ? 1 : 0.35,

              strokeWeight:
                destaque ? 7 : 4,
            });

            // --------------------------------------------
            // MARKERS
            // --------------------------------------------
            if (
              rotaExistente.markers
            ) {
              rotaExistente.markers.forEach(
                (marker) => {
                  marker.setOpacity(
                    destaque ? 1 : 0.35
                  );

                  marker.setIcon({
                    ...criarPinColorido(
                      draw.cor ||
                      "#2563eb"
                    ),

                    scaledSize:
                      new google.maps.Size(
                        destaque
                          ? 38
                          : 32,

                        destaque
                          ? 48
                          : 40
                      ),

                    anchor:
                      new google.maps.Point(
                        destaque
                          ? 19
                          : 16,

                        destaque
                          ? 48
                          : 40
                      ),
                  });
                }
              );
            }
            // ==================================================
            // 10 CICLOS = 5 PISCADAS
            // ==================================================
            if (ciclo >= 10) {
              clearInterval(
                animacao
              );

              rotaExistente.polyline.setOptions(
                {
                  strokeOpacity: 1,
                  strokeWeight: 4,
                }
              );

              if (
                rotaExistente.markers
              ) {
                rotaExistente.markers.forEach(
                  (marker) => {
                    marker.setOpacity(1);

                    marker.setIcon({
                      ...criarPinColorido(
                        draw.cor ||
                        "#2563eb"
                      ),

                      scaledSize:
                        new google.maps.Size(
                          32,
                          40
                        ),

                      anchor:
                        new google.maps.Point(
                          16,
                          40
                        ),
                    });
                  }
                );
              }
            }
          }, 450);

        return;
      }

      // ====================================================
      // A ROTA AINDA NÃO EXISTE NO MAPA
      // ====================================================
      console.log(
        "⚠️ ROTA AINDA NÃO EXISTE. DESENHANDO..."
      );

      if (!center) {
        console.error(
          "❌ CENTER DA ROTA AUSENTE"
        );

        return;
      }

      try {
        const coordinatesArray =
          String(center)
            .split("|")
            .map((coord) => {
              const [lat, lng] =
                coord
                  .replace("(", "")
                  .replace(")", "")
                  .split(",");

              return {
                lat: parseFloat(lat),
                lng: parseFloat(lng),
              };
            })
            .filter(
              (coord) =>
                !isNaN(coord.lat) &&
                !isNaN(coord.lng)
            );

        console.log(
          "COORDENADAS:",
          coordinatesArray
        );

        if (
          coordinatesArray.length === 0
        ) {
          console.error(
            "❌ NENHUMA COORDENADA VÁLIDA"
          );

          return;
        }

        const bounds =
          new google.maps.LatLngBounds();

        coordinatesArray.forEach(
          (coord) => {
            bounds.extend(coord);
          }
        );

        map.fitBounds(bounds);

      } catch (error) {
        console.error(
          "❌ ERRO AO CENTRALIZAR ROTA:",
          error
        );
      }

      return;
    }

    // ======================================================
    // RETÂNGULO
    // ======================================================

    if (
      type === "rectangule" ||
      type === "rectangle"
    ) {
      try {
        const north = Number(draw.north);
        const south = Number(draw.south);
        const east = Number(draw.east);
        const west = Number(draw.west);

        console.log("📐 RETÂNGULO:", {
          north,
          south,
          east,
          west,
        });

        if (
          !isNaN(north) &&
          !isNaN(south) &&
          !isNaN(east) &&
          !isNaN(west)
        ) {
          const bounds =
            new google.maps.LatLngBounds(
              new google.maps.LatLng(
                south,
                west
              ),
              new google.maps.LatLng(
                north,
                east
              )
            );

          map.fitBounds(bounds);

          console.log(
            "🎯 RETÂNGULO CENTRALIZADO"
          );
        } else {
          console.error(
            "❌ COORDENADAS DO RETÂNGULO INVÁLIDAS",
            {
              north: draw.north,
              south: draw.south,
              east: draw.east,
              west: draw.west,
            }
          );
        }
      } catch (error) {
        console.error(
          "❌ ERRO AO CENTRALIZAR RETÂNGULO:",
          error
        );
      }

      return;
    }

    // ======================================================
    // POLÍGONO
    // ======================================================


    if (type === "polygon") {
      try {
        const polygonCoords =
          typeof draw.obj_google === "string"
            ? JSON.parse(draw.obj_google)
            : draw.obj_google;

        if (
          !Array.isArray(polygonCoords) ||
          polygonCoords.length === 0
        ) {
          console.error(
            "❌ NENHUMA COORDENADA DO POLÍGONO ENCONTRADA"
          );

          return;
        }

        console.log(
          "📐 COORDENADAS DO POLÍGONO:",
          polygonCoords
        );

        const bounds =
          new google.maps.LatLngBounds();

        polygonCoords.forEach((coord) => {
          let lat;
          let lng;

          // Formato:
          // { lat: ..., lng: ... }
          if (
            coord &&
            typeof coord === "object" &&
            !Array.isArray(coord)
          ) {
            lat = Number(coord.lat);
            lng = Number(
              coord.lng ?? coord.lon
            );
          }

          // Formato:
          // [lat, lng]
          else if (Array.isArray(coord)) {
            lat = Number(coord[0]);
            lng = Number(coord[1]);
          }

          if (
            !isNaN(lat) &&
            !isNaN(lng)
          ) {
            bounds.extend({
              lat,
              lng,
            });
          }
        });

        if (bounds.isEmpty()) {
          console.error(
            "❌ BOUNDS DO POLÍGONO VAZIO"
          );

          return;
        }

        console.log(
          "🎯 CENTRALIZANDO NO POLÍGONO"
        );

        map.fitBounds(bounds);

      } catch (error) {
        console.error(
          "❌ ERRO AO CENTRALIZAR POLÍGONO:",
          error
        );
      }

      return;
    }
    // ======================================================
    // FALLBACK
    // ======================================================
    if (
      !isNaN(latitude) &&
      !isNaN(longitude)
    ) {
      const point =
        new google.maps.LatLng(
          latitude,
          longitude
        );

      map.panTo(point);
      map.setZoom(15);
    }
  };














  return (

    <>




      <div
        style={{
          backgroundColor: "#f2f4f5bf",
          width: "100%",
          height: "100%",
          position: "fixed",
        }}
      ></div>
















      <ToastContainer />
      <div className="App">

        <Draggable

          cancel=".input-right"
        >

          <input placeholder="Localizar Endereço..." id="input-localizar" className="input-right" />
        </Draggable>

        {/* ============================================================
    CONTAINER PRINCIPAL DO MONITORAMENTO
    ============================================================ */}

        <div className="resp monitoramento-container">








          <div
            className={`${!isTableVisible ? "active-on" : "active"}

            ${!isMapVisible
                ? "wrapper-map2 slide-out"
                : "wrapper-map"}`}

            style={{
              ...(isMapVisible && mapHeight !== null
                ? {
                  "--map-height": `${mapHeight}px`,
                }
                : {}),
            }}
          >





            {/* Mapa */}
            <div
              id="map"


            >


            </div>
            {/*MAPA  Listagem e Filtro de grupos/area e rota */}{" "}

            {isMapVisible && (
              <Draggable>
                <div
                  className="accordion"
                  id="accordionPanelsStayOpenExample"
                  style={{
                    position: "absolute",
                    top: "5rem",
                    left: "12px",
                    zIndex: "1000",
                    width: "270px",
                    borderRadius: "10px",
                  }}
                >











                  {/* Listagem de grupos */}
                  <div className="accordion-item areas-accordion">

                    {/* ===================================================== */}
                    {/* HEADER */}
                    {/* ===================================================== */}

                    <h3 className="accordion-header">

                      <button
                        className="areas-header-btn collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseOne"
                        aria-expanded="false"
                        aria-controls="panelsStayOpen-collapseOne"
                      >

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                          }}
                        >

                          {/* ICON */}
                          <div
                            style={{

                              width: "42px",

                              height: "42px",

                              borderRadius: "14px",

                              background: "rgba(59,130,246,.15)",

                              display: "flex",

                              alignItems: "center",

                              justifyContent: "center",
                            }}
                          >

                            <MdGroups
                              size={20}
                              color="#60a5fa"
                            />

                          </div>

                          {/* TEXT */}
                          <div>

                            <div className="areas-title">

                              Grupos

                            </div>

                            <div className="areas-subtitle">

                              Gerencie grupos ativos

                            </div>

                          </div>

                        </div>

                        {/* SWITCH GLOBAL */}

                        <div
                          className="form-check form-switch m-0"
                          onClick={(e) =>
                            e.stopPropagation()
                          }
                        >

                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="switchAll"
                            checked={!!selectAll}
                            onChange={toggleSelectAll}
                          />

                        </div>

                      </button>

                    </h3>

                    {/* ===================================================== */}
                    {/* BODY */}
                    {/* ===================================================== */}

                    <div
                      id="panelsStayOpen-collapseOne"
                      className="accordion-collapse collapse"
                    >

                      <div
                        style={{
                          padding: "12px",
                        }}
                      >

                        {/* ===================================================== */}
                        {/* SEARCH */}
                        {/* ===================================================== */}

                        <input
                          type="text"
                          className="areas-search"
                          placeholder="Buscar grupo..."
                          onChange={(e) =>
                            setSearchTerm(e.target.value)
                          }
                        />

                        {/* ===================================================== */}
                        {/* LIST */}
                        {/* ===================================================== */}

                        <div className="areas-scroll">

                          {reft

                            .filter((grupo) =>
                              (grupo.nome || "")
                                .toLowerCase()
                                .includes(
                                  (searchTerm || "")
                                    .toLowerCase()
                                )
                            )

                            .map((grupo) => (

                              <li
                                key={grupo.id}
                                className="areas-item"
                              >

                                {/* ===================================================== */}
                                {/* LEFT */}
                                {/* ===================================================== */}

                                <div className="areas-left">

                                  {/* SHAPE */}
                                  <div
                                    className="areas-shape"
                                    style={{

                                      background:
                                        "#3b82f6",

                                      borderRadius:
                                        "10px",
                                    }}
                                  />

                                  {/* INFO */}
                                  <div className="areas-info">

                                    <span className="areas-name">

                                      {grupo.nome}

                                    </span>

                                    <span className="areas-type">

                                      Grupo

                                    </span>

                                  </div>

                                </div>

                                {/* ===================================================== */}
                                {/* ACTIONS */}
                                {/* ===================================================== */}

                                <div className="areas-actions">

                                  <div className="form-check form-switch m-0">

                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      checked={
                                        !!checkedItems1[
                                        grupo.id
                                        ]
                                      }
                                      onChange={() =>
                                        handleCheckboxChang(
                                          grupo.id,
                                          grupo.veiculos
                                        )
                                      }
                                    />

                                  </div>

                                </div>

                              </li>

                            ))}

                        </div>

                      </div>

                    </div>

                  </div>

                  {/* Listagem de Áreas e Rotas */}

                  <div className="accordion-item areas-accordion">

                    {/* ===================================================== */}
                    {/* HEADER */}
                    {/* ===================================================== */}

                    <h3 className="accordion-header">

                      <button
                        className="areas-header-btn collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"

                      >

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                          }}
                        >

                          {/* ICON */}
                          <div
                            style={{

                              width: "42px",

                              height: "42px",

                              borderRadius: "14px",

                              background: "rgba(59,130,246,.15)",

                              display: "flex",

                              alignItems: "center",

                              justifyContent: "center",
                            }}
                          >

                            <MdOutlineAreaChart
                              size={20}
                              color="#60a5fa"
                            />

                          </div>

                          {/* TEXT */}
                          <div>

                            <div className="areas-title">

                              Áreas e Rotas

                            </div>

                            <div className="areas-subtitle">

                              Gerencie referências do mapa

                            </div>

                          </div>

                        </div>

                        {/* SWITCH GLOBAL */}

                        <div className="form-check form-switch m-0">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            checked={formasGlobalVisibility}
                            onChange={(e) => {
                              e.stopPropagation();
                              toggleFormasGlobalVisibility();
                            }}
                          />

                        </div>

                      </button>

                    </h3>

                    {/* ===================================================== */}
                    {/* BODY */}
                    {/* ===================================================== */}

                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse">

                      <div
                        style={{
                          padding: "12px",
                        }}>

                        {/* ===================================================== */}
                        {/* SEARCH */}
                        {/* ===================================================== */}

                        <input
                          type="text"
                          className="areas-search"
                          placeholder="Buscar área ou rota..."
                          onChange={(e) =>
                            setFormasSearchTerm(e.target.value)
                          }
                        />

                        {/* ===================================================== */}
                        {/* LIST */}
                        {/* ===================================================== */}

                        <div className="areas-scroll">

                          {formas

                            .filter((draw) =>
                              draw.tipo !== "ponto" &&


                              draw.descricao
                                ?.toLowerCase()
                                .includes(
                                  formasSearchTerm?.toLowerCase() || ""
                                )
                            )

                            .map((draw) => (

                              <li
                                key={draw.id}
                                className="areas-item"
                              >

                                {/* ===================================================== */}
                                {/* LEFT */}
                                {/* ===================================================== */}

                                <div className="areas-left">

                                  {/* SHAPE */}
                                  <div
                                    className="areas-shape"
                                    style={{

                                      background: draw.cor,

                                      borderRadius:

                                        draw.tipo === "circulo"

                                          ? "50%"

                                          : draw.tipo === "polygon"

                                            ? "4px"

                                            : "2px",

                                      clipPath:

                                        draw.tipo === "polygon"

                                          ? "polygon(50% 0%, 100% 100%, 0% 100%)"

                                          : "none",
                                    }}
                                  />

                                  {/* INFO */}
                                  <div className="areas-info">

                                    <span className="areas-name">

                                      {draw.descricao}

                                    </span>
                                    <span className="areas-type">

                                      {draw.tipo !== "ponto" && draw.tipo}

                                    </span>

                                  </div>

                                </div>

                                {/* ===================================================== */}
                                {/* ACTIONS */}
                                {/* ===================================================== */}

                                <div className="areas-actions">

                                  {/* SWITCH   UNITARIO */}
                                  <div className="form-check form-switch m-0">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      checked={formasIndividualVisibility[draw.id] ?? true}
                                      onChange={(e) => {
                                        e.stopPropagation();
                                        toggleIndividualForma(draw.id);
                                      }}
                                    />

                                  </div>
                                  {/* MAP BUTTON */}
                                  <div
                                    className="areas-icon"
                                    onClick={(e) => {
                                      e.stopPropagation();

                                      console.log("=== CLIQUE NO PIN ===");
                                      console.log("FORMA:", draw);

                                      // Se estiver desligada, liga
                                      if (
                                        formasIndividualVisibility[draw.id] ===
                                        false
                                      ) {
                                        toggleIndividualForma(draw.id);
                                      }

                                      // Centraliza + destaca
                                      handleCenterForma(draw);
                                    }}
                                  >
                                    <MdLocationPin
                                      size={18}
                                      color="#2563eb"
                                    />
                                  </div>
                                </div>

                              </li>

                            ))}

                        </div>

                      </div>

                    </div>

                  </div>
                </div>
              </Draggable>
            )}

            {/* Botoes para esconder mapa e tabela  */}
            <div className={`buttons bbt-ic ${!isMapVisible ? "bt-mp-ic" : "position-absolute bottom-0 end-0"}`}>
              <div className={`button-item ${!isTableVisible ? " off-ic" : ""}`}>


              </div>


              <div className={`button-item ${!isMapVisible ? " off-ic" : ""}`}>


                <div className="button-box shadow" onClick={toggleTableVisibility}>
                  <Tooltip title={isTableVisible ? "Ocultar GRID" : "Exibir GRID"} placement="bottom">
                    <button className="container-botao-grid">
                      <IoGrid className="botao-grid" />

                    </button>
                  </Tooltip>

                </div>
              </div>
            </div>
          </div>

          {/* ============================================================
    BARRA DE REDIMENSIONAMENTO
    ============================================================ */}

          {isMapVisible && (

            <div
              className={`
      map-resize-handle

      ${isResizingMap
                  ? "resizing"
                  : ""
                }
    `}

              // ----------------------------------------------------------
              // Quando o usuário clicar e segurar a barra,
              // inicia o redimensionamento.
              // ----------------------------------------------------------
              onMouseDown={startResizeMap}
            >

              {/* ========================================================
        ÁREA VISUAL DA BARRA
        ======================================================== */}

              <div className="resize-line">

                {/* Pequeno indicador central */}
                <span />

              </div>

            </div>

          )}




          <div className="area-table">

            {/* ============================================================
      TABELA
      ============================================================ */}
            <div
              className={
                !isTableVisible
                  ? "area-table-content slide-out"
                  : "area-table-content slide-in"
              }
            >

              <div className="area-table-inner">

                <Preloader isLoading={isLoading} />

                <MUIDataTable
                  className={`responsiveMode ${!isMapVisible ? "tela-cheia" : ""}`}
                  data={filteredData}
                  columns={columns}
                  options={{
                    ...tableOptions,

                    serverSide: false,
                    pagination: true,
                    viewColumns: false,
                    sort: false,
                    filter: false,

                    tableBodyHeight: "auto",

                    count: data?.total ?? 0,
                    rowsPerPage,
                    rowsPerPageOptions: [5, 10, 20, 50, 100],
                    page: currentPage,

                    search: false,
                    selectableRows: "none",
                    responsive: "standard",

                    onChangePage: setCurrentPage,

                    onChangeRowsPerPage: (n) => {
                      setRowsPerPage(n);
                      setCurrentPage(0);
                    },

                    serverSide: false,
                    pagination: true,
                    viewColumns: false,
                    sort: false,
                    filter: false,

                    // ======================================================
                    // IMPORTANTE:
                    // Antes estava "auto".
                    // Agora a tabela ocupa somente o espaço disponível.
                    // ======================================================
                    tableBodyHeight: "auto",

                    // ======================================================
                    // PAGINAÇÃO AUTOMÁTICA DO MUITABLE
                    // ======================================================
                    count: data?.total ?? 0,
                    rowsPerPage,
                    rowsPerPageOptions: [5, 10, 20, 50, 100],
                    page: currentPage,

                    // ======================================================
                    // UI
                    // ======================================================
                    search: false,
                    selectableRows: "none",
                    responsive: "standard",

                    // ======================================================
                    // EVENTOS
                    // ======================================================
                    onChangePage: setCurrentPage,

                    onChangeRowsPerPage: (n) => {
                      setRowsPerPage(n);
                      setCurrentPage(0);
                    },

                    // ======================================================
                    // TOOLBAR
                    // ======================================================
                    customToolbar: () => (
                      <div
                        style={{
                          display: "flex",
                          marginTop: "-45px",
                          padding: "8px 24px",
                          width: "90%",
                          flexWrap: "nowrap",
                        }}
                      >

                        {/* ==================================================
                  ESQUERDA
                  ================================================== */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "16px",
                            flex: 1,
                          }}
                        >

                          <b
                            style={{
                              color: "white",
                              margin: 0,
                              whiteSpace: "nowrap",
                              fontSize: "16px",
                              marginLeft: "-20px",
                              letterSpacing: "1px",
                              textTransform: "uppercase",
                              textShadow: "0px 0px 2px black",
                            }}
                          >
                            Última atualização: {dataAgora}
                          </b>

                          {/* ATUALIZAR */}
                          <span
                            onClick={() => {
                              if (!isFetching) {
                                refetch();
                              }
                            }}
                            style={{
                              cursor: isFetching
                                ? "not-allowed"
                                : "pointer",

                              border: "none",

                              opacity: isFetching
                                ? 0.6
                                : 1,

                              pointerEvents: isFetching
                                ? "none"
                                : "auto",
                            }}
                          >
                            {isFetching ? (
                              <CircularProgress
                                size={22}
                                style={{
                                  color: "#F2F4F5",
                                }}
                              />
                            ) : (
                              <RefreshIcon
                                style={{
                                  color: "#F2F4F5",
                                  fontSize: "22pt",
                                }}
                              />
                            )}
                          </span>

                          {/* PERSONALIZAR COLUNAS */}
                          <Tooltip title="Personalizar Colunas">
                            <button
                              onClick={abrirConfiguracaoColunas}
                              style={{
                                background: "transparent",
                                border: "none",
                                cursor: "pointer",
                                color: "#F2F4F5",
                                fontSize: "18px",
                                marginLeft: "30rem",
                                display: "flex",
                                position: "absolute",
                              }}
                            >
                              <SettingsIcon />
                            </button>
                          </Tooltip>

                          {/* ==================================================
                    BOTÃO / CONTROLE DO MAPA

                    IMPORTANTE:
                    Não usar mais "wrapper-map" aqui.
                    Essa div NÃO é o mapa.
                    ================================================== */}
                          <div
                            className={`
                    ${!isTableVisible
                                ? "active-on"
                                : "active"
                              }

                    ${!isMapVisible
                                ? "map-control"
                                : "map-control slide-in"
                              }
                  `}
                            style={{
                              marginTop: "0",
                            }}
                          >
                            <div
                              className="buttons"
                              style={{
                                marginLeft: "0",
                              }}
                            >
                              <div
                                className={`button-item ${!isTableVisible
                                  ? "off-ic"
                                  : ""
                                  }`}
                              >
                              </div>
                            </div>
                          </div>

                        </div>


                        {/* ====================================================
                  ALERTA
                  ==================================================== */}
                        <div
                          style={{
                            left: "35rem",
                            top: "0.5rem",
                            position: "absolute",
                          }}
                        >
                          <Alerta_Grid />
                        </div>


                        {/* ====================================================
                  MOSTRAR / ESCONDER MAPA
                  ==================================================== */}
                        <Tooltip
                          title={
                            isMapVisible
                              ? "Ocultar MAPA"
                              : "Exibir MAPA"
                          }
                          placement="bottom"
                        >
                          <button className="botao_ocutar-mapa">
                            <FaMap
                              className="icone_mapa_ocultar"
                              onClick={toggleMapVisibility}
                            />
                          </button>
                        </Tooltip>


                        {/* ====================================================
                  BUSCA
                  ==================================================== */}
                        <div className="input-busca-wrapper">
                          <input
                            type="search"
                            placeholder="Buscar motorista, data ou endereço..."
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            className="input-buscar"
                          />
                        </div>

                      </div>
                    ),
                  }}
                />

              </div>


              {/* ==========================================================
        PAGINAÇÃO
        ========================================================== */}
              <Pagination
                currentPage={currentPage}
                handlePagination={setCurrentPage}

                limits={(e) => {
                  setRowsPerPage(
                    parseInt(e.target.value, 10)
                  );

                  setCurrentPage(1);
                }}

                currentLimit={rowsPerPage}

                totalItems={filteredData.length}
              />

            </div>

          </div>
        </div>
      </div>



      <div>



      </div>

    </>



  );
};

export default MapaInova;
